unit unit_PZE;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, WEBLib.DBCtrls, WEBLib.Buttons, Vcl.Controls,
  Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.ExtCtrls, Data.DB, strutils,
  XData.Web.JsonDataset, XData.Web.Dataset, WEBLib.DB, WEBLib.Grids, dateutils,
  Vcl.Grids, DB;

type
  TPZE = class(TForm)
    xdsSingleArbeitszeit: TXDataWebDataSet;
    xdsSingleArbeitszeitID: TStringField;
    sourceSingleArbeitszeit: TDataSource;
    xdsSingleArbeitszeitPersonalnummer: TIntegerField;
    xdsSingleArbeitszeitDatum: TDateTimeField;
    xdsSingleArbeitszeitEintragsArt: TIntegerField;
    xdsScan: TXDataWebDataSet;
    sourceScan: TDataSource;
    xdsScanPersonalnummer: TIntegerField;
    xdsScanScanDatumZeit: TDateTimeField;
    xdsScanDatum: TDateTimeField;
    xdsScanScanArt: TIntegerField;
    xdsScanObjektreferenz: TStringField;
    xdsScanScanBegin: TDateTimeField;
    xdsScanScanEnde: TDateTimeField;
    xdsScanausgewertet: TBooleanField;
    xdsScanAMS: TFloatField;
    xdsScanStundenArt: TStringField;
    xdsScanFAID: TXDataWebEntityField;
    xdsScanID: TStringField;
    panelfunktionen: TPanel;
    btnAnmelden: TButton;
    btnPauseBeginn: TButton;
    btnPauseEnde: TButton;
    btnAbmelden: TButton;
    btnObjektBeginn: TButton;
    btnObjektEnde: TButton;
    btnErneutAnmelden: TButton;
    Container1: THTMLContainer;
    Container2: THTMLContainer;
    btnzurueck: TButton;
    lblstatus: TLabel;
    lblPInfo: TLabel;
    WebDBLabel2: TDBLabel;
    TC: TTableControl;
    xdsScanKundennummer: TStringField;
    xdsScanAuftrag: TStringField;
    xdsScanPAuftrag: TStringField;
    xdsScanArbeitArt: TStringField;
    xdsScanInfos: TStringField;
    xdsScanDauerMinuten: TFloatField;
    btnKontaktBeginn: TButton;
    btnKontaktEnde: TButton;
    xdsPZEEinstellungen: TXDataWebDataSet;
    sourcePZEEinstellungen: TDataSource;
    xdsPZEEinstellungenZuordnungObjekt: TIntegerField;
    xdsPZEEinstellungenZuordnungKontakt: TIntegerField;
    xdsPZEEinstellungenZuordnungAuftrag: TIntegerField;
    xdsPZEEinstellungenZuordnungProduktion: TIntegerField;
    btnAuftragBeginn: TButton;
    btnAuftragEnde: TButton;
    btnProduktionBeginn: TButton;
    btnProduktionEnde: TButton;
    panelArbeitsart: TPanel;
    radioarbeitsart: TRadioGroup;
    btnOK: TButton;
    btnAbbrechen: TButton;
    lblauswahlinfo: TLabel;
    panelstundenart: TPanel;
    lblauswahlobjekt: TLabel;
    btnObjektOK: TButton;
    btnObjektAbbrechen: TButton;
    xdsStundenart: TXDataWebDataSet;
    sourceStundenart: TDataSource;
    xdsStundenartStundenArt: TStringField;
    lookupstundenart: TComboBox;
    xdsPZEEinstellungenAuswahlNurKontaktnummer: TIntegerField;
    xdsScanKalkStundensatz: TFloatField;
    xdsScanKalkKosten: TFloatField;
    btnPauseVorgabe: TButton;
    xdsSingleArbeitszeitSollPause: TDateTimeField;
    xdsPZEEinstellungenPauseVorgabe: TIntegerField;
    xdsPauseFix: TXDataWebDataSet;
    xdsPauseFixFAID: TXDataWebEntityField;
    xdsPauseFixID: TStringField;
    xdsPauseFixPersonalnummer: TIntegerField;
    xdsPauseFixScanDatumZeit: TDateTimeField;
    xdsPauseFixDatum: TDateTimeField;
    xdsPauseFixScanArt: TIntegerField;
    xdsPauseFixObjektreferenz: TStringField;
    xdsPauseFixScanBegin: TDateTimeField;
    xdsPauseFixScanEnde: TDateTimeField;
    xdsPauseFixausgewertet: TBooleanField;
    xdsPauseFixAMS: TFloatField;
    xdsPauseFixStundenArt: TStringField;
    xdsPauseFixKundennummer: TStringField;
    xdsPauseFixAuftrag: TStringField;
    xdsPauseFixPAuftrag: TStringField;
    xdsPauseFixArbeitArt: TStringField;
    xdsPauseFixInfos: TStringField;
    xdsPauseFixDauerMinuten: TFloatField;
    xdsPauseFixKalkStundensatz: TFloatField;
    xdsPauseFixKalkKosten: TFloatField;
    lblAutoObjekt: TLabel;
    lblAutoAuftrag: TLabel;
    procedure WebFormShow(Sender: TObject);
    procedure xdsSingleArbeitszeitAfterOpen(DataSet: TDataSet);
    procedure btnAnmeldenClick(Sender: TObject);
    procedure xdsScanNewRecord(DataSet: TDataSet);
    procedure btnPauseBeginnClick(Sender: TObject);
    procedure btnPauseEndeClick(Sender: TObject);
    procedure xdsScanAfterPost(DataSet: TDataSet);
    procedure xdsScanAfterApplyUpdates(Sender: TDataSet; Info: TResolveResults);
    procedure xdsScanAfterOpen(DataSet: TDataSet);
    procedure btnAbmeldenClick(Sender: TObject);
    procedure btnErneutAnmeldenClick(Sender: TObject);
    procedure btnObjektEndeClick(Sender: TObject);
    procedure btnObjektBeginnClick(Sender: TObject);
    procedure btnzurueckClick(Sender: TObject);
    procedure xdsPZEEinstellungenAfterOpen(DataSet: TDataSet);
    procedure btnKontaktEndeClick(Sender: TObject);
    procedure btnKontaktBeginnClick(Sender: TObject);
    procedure btnOKClick(Sender: TObject);
    procedure btnAbbrechenClick(Sender: TObject);
    procedure btnAuftragBeginnClick(Sender: TObject);
    procedure btnAuftragEndeClick(Sender: TObject);
    procedure btnProduktionEndeClick(Sender: TObject);
    procedure btnProduktionBeginnClick(Sender: TObject);
    procedure btnObjektAbbrechenClick(Sender: TObject);
    procedure btnObjektOKClick(Sender: TObject);
    procedure xdsStundenartAfterOpen(DataSet: TDataSet);
    procedure btnPauseVorgabeClick(Sender: TObject);
    procedure xdsPauseFixAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure xdsPauseFixAfterOpen(DataSet: TDataSet);
    procedure xdsPauseFixAfterPost(DataSet: TDataSet);
  private
    { Private-Deklarationen }
  public
    { Public-Deklarationen }
    procedure showstatus;
    procedure kontaktsuche1;
    procedure kontaktsuche2;
  protected procedure LoadDFMValues; override; end;

var
  PZE: TPZE;
  ftjahr,ftmonat,fttag,ftstunde,ftminute,ftsekunde,ftms:word;
  fjjahr,fjmonat,fjtag,fjstunde,fjminute,fjsekunde,fjms:word;
  datumohnezeit:string;
  mytempdatumzeit:TDateTime;
  myScanArt:integer;
  myDoApply:integer;
  myObjektReferenz:string;
  myKontaktReferenz:string;
  myAuftragReferenz:string;
  myProduktionReferenz:string;
  myInfos:string;
  myArbeitArt:string;
  myStundenart:string;
  myPauseSoll:TDateTime;
  myPauseVorgabe:integer;

  //ScanArten
  // 1=Anmelden
  // 2=Pause
  // 3=Pause Ende
  // 4=Objekt
  // 5=Objekt Ende
  // 9=Abmelden
  // 14=Kontakt
  // 15=Kontak Ende
  // 24=Auftrag
  // 25=AuftragEnde
  // 34=Produktion
  // 35=ProduktionEnde

implementation
  uses unit1, unit2, unit_objektsuche, unit_Kontaktsuche, unit_AuftragSuche, unit_produktionSuche, unit_Kontaktnummersuche;
{$R *.dfm}

procedure TPZE.btnAbbrechenClick(Sender: TObject);
begin
  panelArbeitsart.Visible:=false;
  showstatus;
end;

procedure TPZE.btnAbmeldenClick(Sender: TObject);
begin
  myDoApply:=0;
  mytempdatumzeit:=date+time;
  decodedatetime(mytempdatumzeit,ftjahr,ftmonat,fttag,ftstunde,ftminute,ftsekunde,ftms);
  myScanArt:=9;
  xdsscan.Last;
  xdsscan.Edit;
  xdsScanScanEnde.AsDateTime:=encodetime(ftstunde,ftminute,0,0);
  xdsscan.Post;
  myDoApply:=1;
  xdsscan.Append;
end;

procedure TPZE.btnAnmeldenClick(Sender: TObject);
begin
  mytempdatumzeit:=date+time;
  decodedatetime(mytempdatumzeit,ftjahr,ftmonat,fttag,ftstunde,ftminute,ftsekunde,ftms);
  mydoapply:=1;
  myscanart:=1;
  xdsSCAN.Append;
end;

procedure TPZE.btnAuftragBeginnClick(Sender: TObject);
var
  LFrm:TfrmAuftragSuche;
    procedure AfterCreate(AForm:TObject);
    var
      LForm:TfrmAuftragSuche;
    begin
      LForm:=(AForm as TfrmAuftragSuche);
      lform.Auftragnummer:='';
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      if lfrm.Auftragnummer<>'' then
      begin
        myAuftragReferenz:=lfrm.Auftragnummer;
        myInfos:=trim(lfrm.LUAuftragsbezeichnung);
        myDoApply:=0;
        myScanArt:=24;
        panelfunktionen.Visible:=false;
        panelArbeitsart.Visible:=true;
        lblauswahlinfo.Caption:=myAuftragReferenz+' '+myinfos;

      end;
      if lfrm.Auftragnummer='' then
      begin
        showmessage('Der Vorgang wird abgebrochen, da Sie keinen Auftrag ausgewählt haben');
      end;

    end;

  begin
  LFrm:=TfrmAuftragSuche.CreateNew(@AfterCreate);
 // LFrm.Popup:=true;
  LFrm.ShowModal(@AfterShowmodal);
end;

procedure TPZE.btnAuftragEndeClick(Sender: TObject);
begin
  myDoApply:=0;
  mytempdatumzeit:=date+time;
  decodedatetime(mytempdatumzeit,ftjahr,ftmonat,fttag,ftstunde,ftminute,ftsekunde,ftms);
  myScanArt:=25;
  xdsscan.Last;
  xdsscan.Edit;
  xdsScanScanEnde.AsDateTime:=encodetime(ftstunde,ftminute,0,0);
  xdsScanDauerMinuten.AsFloat:=Minutesbetween(xdsScanScanBegin.AsDateTime,xdsScanScanEnde.AsDateTime);
  xdsScanKalkStundensatz.AsFloat:=BenutzerStundensatzIntern;

  try
    xdsScanKalkKosten.AsFloat:=xdsScanKalkStundensatz.AsFloat/60*xdsScanDauerMinuten.AsFloat;
  except

  end;

  xdsscan.Post;
  myDoApply:=1;
  xdsscan.Append;
end;

procedure TPZE.btnErneutAnmeldenClick(Sender: TObject);
begin
  myDoApply:=0;
  mytempdatumzeit:=date+time;
  decodedatetime(mytempdatumzeit,ftjahr,ftmonat,fttag,ftstunde,ftminute,ftsekunde,ftms);
  myScanArt:=3;
  xdsscan.Last;
  xdsscan.Edit;
  xdsScanScanEnde.AsDateTime:=encodetime(ftstunde,ftminute,0,0);
  xdsScanScanArt.AsInteger:=2;
  xdsscan.Post;
  myDoApply:=1;
  xdsscan.Append;
end;

procedure TPZE.btnKontaktBeginnClick(Sender: TObject);
begin
  if xdsPZEEinstellungenAuswahlNurKontaktnummer.AsInteger=0 then kontaktsuche1;
  if xdsPZEEinstellungenAuswahlNurKontaktnummer.AsInteger=1 then kontaktsuche2;
end;

procedure TPZE.btnKontaktEndeClick(Sender: TObject);
begin
  myDoApply:=0;
  mytempdatumzeit:=date+time;
  decodedatetime(mytempdatumzeit,ftjahr,ftmonat,fttag,ftstunde,ftminute,ftsekunde,ftms);
  myScanArt:=15;
  xdsscan.Last;
  xdsscan.Edit;
  xdsScanScanEnde.AsDateTime:=encodetime(ftstunde,ftminute,0,0);
  xdsScanDauerMinuten.AsFloat:=Minutesbetween(xdsScanScanBegin.AsDateTime,xdsScanScanEnde.AsDateTime);
  xdsScanKalkStundensatz.AsFloat:=BenutzerStundensatzIntern;

  try
    xdsScanKalkKosten.AsFloat:=xdsScanKalkStundensatz.AsFloat/60*xdsScanDauerMinuten.AsFloat;
  except

  end;

  xdsscan.Post;
  myDoApply:=1;
  xdsscan.Append;
end;

procedure TPZE.btnObjektAbbrechenClick(Sender: TObject);
begin
  panelstundenart.Visible:=false;
  showstatus;
end;

procedure TPZE.btnObjektBeginnClick(Sender: TObject);
var
  LFrm:TfrmObjektsuche;
    procedure AfterCreate(AForm:TObject);
    var
      LForm:TfrmObjektsuche;
    begin
      LForm:=(AForm as TfrmObjektsuche);
      lform.Objektreferenz:='';
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      if lfrm.Objektreferenz<>'' then
      begin
        myobjektreferenz:=lfrm.Objektreferenz;
        myinfos:=trim(lfrm.luObjektnummer+' '+lfrm.luObjektkurzbezeichnung);
        myDoApply:=0;
        mytempdatumzeit:=date+time;
        decodedatetime(mytempdatumzeit,ftjahr,ftmonat,fttag,ftstunde,ftminute,ftsekunde,ftms);
        myScanArt:=4;
        panelfunktionen.Visible:=false;
        panelstundenart.Visible:=true;
        lookupstundenart.text:='[-]';
        lblauswahlobjekt.Caption:=myobjektreferenz+' '+myinfos;

      end;
      if lfrm.Objektreferenz='' then
      begin
        showmessage('Der Vorgang wird abgebrochen, da Sie kein Objekt ausgewählt haben');
      end;

    end;

  begin
  LFrm:=TfrmObjektsuche.CreateNew(@AfterCreate);
 // LFrm.Popup:=true;
  LFrm.ShowModal(@AfterShowmodal);

end;

procedure TPZE.btnObjektEndeClick(Sender: TObject);
begin
  myDoApply:=0;
  mytempdatumzeit:=date+time;
  decodedatetime(mytempdatumzeit,ftjahr,ftmonat,fttag,ftstunde,ftminute,ftsekunde,ftms);
  myScanArt:=5;
  xdsscan.Last;
  xdsscan.Edit;
  xdsScanScanEnde.AsDateTime:=encodetime(ftstunde,ftminute,0,0);
  xdsScanDauerMinuten.AsFloat:=Minutesbetween(xdsScanScanBegin.AsDateTime,xdsScanScanEnde.AsDateTime);
  xdsscan.Post;
  myDoApply:=1;
  xdsscan.Append;
end;

procedure TPZE.btnObjektOKClick(Sender: TObject);
begin
  panelstundenart.Visible:=false;
  mytempdatumzeit:=date+time;
  myArbeitArt:='[-]';
  mystundenart:=lookupstundenart.text;
  decodedatetime(mytempdatumzeit,ftjahr,ftmonat,fttag,ftstunde,ftminute,ftsekunde,ftms);
  xdsscan.Last;
  xdsscan.Edit;
  xdsScanScanEnde.AsDateTime:=encodetime(ftstunde,ftminute,0,0);
  xdsscan.Post;
  myDoApply:=1;
  xdsscan.Append;
end;

procedure TPZE.btnOKClick(Sender: TObject);
begin
        panelArbeitsart.Visible:=false;
        mytempdatumzeit:=date+time;
        myArbeitArt:='[-]';
        if radioarbeitsart.ItemIndex=1 then myArbeitArt:='Arbeitszeit';
        if radioarbeitsart.ItemIndex=2 then myArbeitArt:='Fahrzeit';


        decodedatetime(mytempdatumzeit,ftjahr,ftmonat,fttag,ftstunde,ftminute,ftsekunde,ftms);

        xdsscan.Last;
        xdsscan.Edit;
        xdsScanScanEnde.AsDateTime:=encodetime(ftstunde,ftminute,0,0);
        xdsscan.Post;
        myDoApply:=1;
        xdsscan.Append;
end;

procedure TPZE.btnPauseBeginnClick(Sender: TObject);
begin
  myDoApply:=0;
  mytempdatumzeit:=date+time;
  decodedatetime(mytempdatumzeit,ftjahr,ftmonat,fttag,ftstunde,ftminute,ftsekunde,ftms);
  myScanArt:=2;
  xdsscan.Last;
  xdsscan.Edit;
  xdsScanScanEnde.AsDateTime:=encodetime(ftstunde,ftminute,0,0);
  xdsscan.Post;
  myDoApply:=1;
  myInfos:='Pause';
  myPauseVorgabe:=0;
  xdsscan.Append;
end;

procedure TPZE.btnPauseEndeClick(Sender: TObject);
begin
  myDoApply:=0;
  mytempdatumzeit:=date+time;
  decodedatetime(mytempdatumzeit,ftjahr,ftmonat,fttag,ftstunde,ftminute,ftsekunde,ftms);
  myScanArt:=3;
  xdsscan.Last;
  xdsscan.Edit;
  xdsScanScanEnde.AsDateTime:=encodetime(ftstunde,ftminute,0,0);
  xdsScanDauerMinuten.AsFloat:=Minutesbetween(xdsScanScanBegin.AsDateTime,xdsScanScanEnde.AsDateTime);
  xdsscan.Post;
  myDoApply:=1;
  xdsscan.Append;
end;

procedure TPZE.btnPauseVorgabeClick(Sender: TObject);
begin
  xdsPauseFix.Load;
end;

procedure TPZE.btnProduktionBeginnClick(Sender: TObject);
var
  LFrm:TfrmProduktionSuche;
    procedure AfterCreate(AForm:TObject);
    var
      LForm:TfrmProduktionSuche;
    begin
      LForm:=(AForm as TfrmProduktionSuche);
      lform.Produktionnummer:='';
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      if lfrm.Produktionnummer<>'' then
      begin
        myProduktionReferenz:=lfrm.Produktionnummer;
        myInfos:=trim(lfrm.LUAuftragsbezeichnung);
        myDoApply:=0;
        myScanArt:=34;
        mytempdatumzeit:=date+time;
        myArbeitArt:='[-]';
        decodedatetime(mytempdatumzeit,ftjahr,ftmonat,fttag,ftstunde,ftminute,ftsekunde,ftms);
        xdsscan.Last;
        xdsscan.Edit;
        xdsScanScanEnde.AsDateTime:=encodetime(ftstunde,ftminute,0,0);
        xdsscan.Post;
        myDoApply:=1;
        xdsscan.Append;

      end;
      if lfrm.Produktionnummer='' then
      begin
        showmessage('Der Vorgang wird abgebrochen, da Sie keinen Produktions-Auftrag ausgewählt haben');
      end;

    end;

  begin
  LFrm:=TfrmProduktionSuche.CreateNew(@AfterCreate);
 // LFrm.Popup:=true;
  LFrm.ShowModal(@AfterShowmodal);

end;

procedure TPZE.btnProduktionEndeClick(Sender: TObject);
begin
  myDoApply:=0;
  mytempdatumzeit:=date+time;
  decodedatetime(mytempdatumzeit,ftjahr,ftmonat,fttag,ftstunde,ftminute,ftsekunde,ftms);
  myScanArt:=35;
  xdsscan.Last;
  xdsscan.Edit;
  xdsScanScanEnde.AsDateTime:=encodetime(ftstunde,ftminute,0,0);
  xdsScanDauerMinuten.AsFloat:=Minutesbetween(xdsScanScanBegin.AsDateTime,xdsScanScanEnde.AsDateTime);
  xdsScanKalkStundensatz.AsFloat:=BenutzerStundensatzIntern;

  try
    xdsScanKalkKosten.AsFloat:=xdsScanKalkStundensatz.AsFloat/60*xdsScanDauerMinuten.AsFloat;
  except

  end;

  xdsscan.Post;
  myDoApply:=1;
  xdsscan.Append;
end;

procedure TPZE.btnzurueckClick(Sender: TObject);
begin
  self.Close;
end;

procedure TPZE.showstatus;
begin
  xdsscan.Close;
  xdsPZEEinstellungen.Close;
  xdsPZEEinstellungen.Load;
end;

procedure TPZE.WebFormShow(Sender: TObject);
var
  myelement:TJSHTMLElement;
begin
  Container1.html.text:='<nav class="navbar m-1 rounded bg-info"><h5>PZE-Zeiterfassung</h5></nav>';
  myelement:=container1.ElementHandle;
  btnzurueck.ParentElement:=myelement;
  lblpinfo.ParentElement:=myelement;
  webdblabel2.ParentElement:=myelement;
  lblstatus.ParentElement:=myelement;
  lblAutoObjekt.ParentElement:=myelement;
  lblAutoAuftrag.ParentElement:=myelement;
  myelement:=container2.ElementHandle;
  panelfunktionen.ParentElement:=myelement;
  panelarbeitsart.ParentElement:=myelement;
  panelstundenart.ParentElement:=myelement;
  lblpinfo.Caption:=BenutzerPersonalnummer+' '+BenutzerVorname+' '+BenutzerNachname;
  panelarbeitsart.Visible:=false;
  panelstundenart.Visible:=false;
  myDoApply:=0;
  showstatus;

end;

procedure TPZE.xdsPauseFixAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
  var
  i:integer;
begin
  for i := 0 to High(info.Records) do
  begin
    if info.Records[i].Error<>'' then showmessage(info.Records[i].Error);
  end;
  showstatus;
end;

procedure TPZE.xdsPauseFixAfterOpen(DataSet: TDataSet);
begin
  myDoApply:=0;
  mytempdatumzeit:=date+time;
  decodedatetime(mytempdatumzeit,ftjahr,ftmonat,fttag,ftstunde,ftminute,ftsekunde,ftms);
  xdsPauseFix.Last;
  xdsPauseFix.Edit;
  xdsPauseFixScanEnde.AsDateTime:=encodetime(ftstunde,ftminute,0,0);
  xdsPauseFix.Post;
  xdsPauseFix.Append;

  xdsPauseFixFAID.Value:=xdsSingleArbeitszeit.CurrentData;
  xdsPauseFixPersonalnummer.AsString:=Benutzerpersonalnummer;
  xdsPauseFixScanDatumZeit.AsDateTime:=mytempdatumzeit;
  xdsPauseFixDatum.AsDateTime:=encodedate(ftjahr,ftmonat,fttag);
  xdsPauseFixScanArt.AsInteger:=2;
  xdsPauseFixScanBegin.AsDateTime:=encodetime(ftstunde,ftminute,0,0);
  xdsPauseFixausgewertet.AsBoolean:=false;
  xdsPauseFixAMS.AsFloat:=ftms;
  xdsPauseFixObjektreferenz.AsString:='';
  xdsPauseFixKundennummer.AsString:='';
  xdsPauseFixAuftrag.AsString:='';
  xdsPauseFixPAuftrag.AsString:='';
  xdsPauseFixStundenArt.AsString:='[-]';
  xdsPauseFixArbeitArt.AsString:='[-]';
  xdsPauseFixDauerMinuten.AsFloat:=0;
  xdsPauseFixInfos.AsString:='Pause';
  xdsPauseFixKalkStundensatz.AsFloat:=0;
  xdsPauseFixKalkKosten.AsFloat:=0;
  xdsPauseFixScanEnde.AsDateTime:=encodetime(ftstunde,ftminute,0,0)+myPauseSoll;
  xdsPauseFixDauerMinuten.AsFloat:=Minutesbetween(xdsPauseFixScanBegin.AsDateTime,xdsPauseFixScanEnde.AsDateTime);
  myDoApply:=0;
  xdsPauseFix.Post;
  xdsPauseFix.Append;
  xdsPauseFixFAID.Value:=xdsSingleArbeitszeit.CurrentData;
  xdsPauseFixPersonalnummer.AsString:=Benutzerpersonalnummer;
  xdsPauseFixScanDatumZeit.AsDateTime:=mytempdatumzeit+myPauseSoll;
  xdsPauseFixDatum.AsDateTime:=encodedate(ftjahr,ftmonat,fttag);
  xdsPauseFixScanArt.AsInteger:=3;
  xdsPauseFixScanBegin.AsDateTime:=encodetime(ftstunde,ftminute,0,0)+myPauseSoll;
  xdsPauseFixausgewertet.AsBoolean:=false;
  xdsPauseFixAMS.AsFloat:=ftms+1;
  xdsPauseFixObjektreferenz.AsString:='';
  xdsPauseFixKundennummer.AsString:='';
  xdsPauseFixAuftrag.AsString:='';
  xdsPauseFixPAuftrag.AsString:='';
  xdsPauseFixStundenArt.AsString:='[-]';
  xdsPauseFixArbeitArt.AsString:='[-]';
  xdsPauseFixDauerMinuten.AsFloat:=0;
  xdsPauseFixInfos.AsString:='';
  xdsPauseFixKalkStundensatz.AsFloat:=0;
  xdsPauseFixKalkKosten.AsFloat:=0;
  xdsPauseFixDauerMinuten.AsFloat:=0;
  myDoApply:=1;
  xdsPauseFix.Post;

end;

procedure TPZE.xdsPauseFixAfterPost(DataSet: TDataSet);
begin
  if myDoApply=1 then xdsPauseFix.ApplyUpdates;
end;

procedure TPZE.xdsPZEEinstellungenAfterOpen(DataSet: TDataSet);
begin
  xdsstundenart.Close;
  xdsstundenart.load;
end;

procedure TPZE.xdsScanAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
  var
  i:integer;
begin
  for i := 0 to High(info.Records) do
  begin
    if info.Records[i].Error<>'' then showmessage(info.Records[i].Error);
  end;
  showstatus;
end;

procedure TPZE.xdsScanAfterOpen(DataSet: TDataSet);
var
  i:integer;
  infostext:string;
begin
  xdsscan.First;
  tc.RowCount:=xdsscan.RecordCount+1;
  tc.ColCount:=6;
  i:=0;
  tc.Cells[0,i]:='DatumZeit';
  tc.Cells[1,i]:='Beginn';
  tc.Cells[2,i]:='Ende';
  tc.Cells[3,i]:='Minuten';
  tc.Cells[4,i]:='Infos';

  while not xdsscan.eof do
  begin
    inc(i);
    tc.Cells[0,i]:=formatdatetime('DD.MM.YYYY hh:mm:ss', xdsScanScanDatumZeit.asdatetime);
    tc.Cells[1,i]:=formatdatetime('hh:mm:ss', xdsScanScanBegin.asdatetime);
    tc.Cells[2,i]:=formatdatetime('hh:mm:ss', xdsScanScanEnde.asdatetime);
    tc.Cells[3,i]:=xdsScanDauerMinuten.asstring;
    infostext:='';
    if xdsScanScanArt.AsInteger=2 then
    begin
      infostext:='Pause';
    end;
    if xdsScanScanArt.AsInteger=4 then
    begin
      infostext:='Objekt: '+xdsScanObjektreferenz.AsString+' '+xdsScanInfos.AsString+ ' ('+xdsScanStundenArt.asstring+')';
    end;
    if xdsScanScanArt.AsInteger=5 then
    begin
      infostext:='';
    end;
    if xdsScanScanArt.AsInteger=9 then
    begin
      infostext:='abgemeldet';
    end;
    if xdsScanScanArt.AsInteger=14 then
    begin
      infostext:='Kontakt: '+xdsScanKundennummer.AsString+' '+xdsScanInfos.AsString+ ' ('+xdsScanArbeitArt.asstring+')';
    end;
    if xdsScanScanArt.AsInteger=15 then
    begin
      infostext:='';
    end;
    if xdsScanScanArt.AsInteger=24 then
    begin
      infostext:='Auftrag: '+xdsScanAuftrag.AsString+' '+xdsScanInfos.AsString+ ' ('+xdsScanArbeitArt.asstring+')';
    end;
    if xdsScanScanArt.AsInteger=25 then
    begin
      infostext:='';
    end;
    if xdsScanScanArt.AsInteger=34 then
    begin
      infostext:='Produktion: '+xdsScanPAuftrag.AsString+' '+xdsScanInfos.AsString+ ' ('+xdsScanArbeitArt.asstring+')';
    end;
    if xdsScanScanArt.AsInteger=35 then
    begin
      infostext:='';
    end;

    tc.Cells[4,i]:=infostext;

    xdsscan.Next;
  end;

  decodedatetime(date+time,fjjahr,fjmonat,fjtag,fjstunde,fjminute,fjsekunde,fjms);
  xdsscan.last;
  panelArbeitsart.Visible:=false;
  panelstundenart.Visible:=false;
  panelfunktionen.Visible:=true;
  btnanmelden.Visible:=false;
  btnabmelden.Visible:=false;
  btnPauseBeginn.Visible:=false;
  btnpauseende.Visible:=false;
  btnPauseVorgabe.Visible:=false;
  btnobjektbeginn.Visible:=false;
  btnobjektende.Visible:=false;
  btnErneutAnmelden.Visible:=false;
  btnKontaktBeginn.Visible:=false;
  btnKontaktEnde.Visible:=false;
  btnAuftragBeginn.Visible:=false;
  btnAuftragEnde.visible:=false;
  btnProduktionBeginn.Visible:=false;
  btnProduktionEnde.Visible:=false;
  if xdsScanScanArt.AsString='' then
  begin
    btnAnmelden.Visible:=true;
    lblstatus.Caption:='Sie haben sich heute noch nicht angemeldet';
  end;
  if xdsScanScanArt.AsInteger=1 then
  begin
    btnabmelden.visible:=true;
    btnPauseBeginn.visible:=true;
    btnObjektBeginn.visible:=true;
    btnKontaktBeginn.Visible:=true;
    btnAuftragBeginn.Visible:=true;
    btnProduktionBeginn.Visible:=true;
    lblstatus.Caption:='Sie sind in der Zeiterfassung angemeldet';
  end;

  if xdsScanScanArt.AsInteger=2 then
  begin
    btnPauseEnde.Visible:=true;
    lblstatus.Caption:='Sie sind momentan in einer Pause';
  end;

  if xdsScanScanArt.AsInteger=3 then
  begin
    btnabmelden.visible:=true;
    btnPauseBeginn.visible:=true;
    btnObjektBeginn.visible:=true;
    btnKontaktBeginn.Visible:=true;
    btnAuftragBeginn.Visible:=true;
    btnProduktionBeginn.Visible:=true;
    lblstatus.Caption:='Pause beendet';
  end;

  if xdsScanScanArt.AsInteger=4 then
  begin
    btnObjektEnde.visible:=true;
    lblstatus.Caption:='Objekt: '+xdsSCANObjektreferenz.AsString+' '+xdsSCANInfos.asstring+ ' ('+xdsScanStundenArt.asstring+')';
  end;

  if xdsScanScanArt.AsInteger=5 then
  begin
    btnabmelden.visible:=true;
    btnPauseBeginn.visible:=true;
    btnObjektBeginn.visible:=true;
    btnKontaktBeginn.Visible:=true;
    btnAuftragBeginn.Visible:=true;
    btnProduktionBeginn.Visible:=true;
    lblstatus.Caption:='Objekt beendet';
  end;

  if xdsScanScanArt.AsInteger=14 then
  begin
    lblstatus.Caption:='Kontakt: '+xdsSCANKundennummer.AsString+' ('+xdsSCANArbeitArt.asstring+') '+xdsSCANInfos.asstring;
    btnKontaktEnde.Visible:=true;
  end;

  if xdsScanScanArt.AsInteger=15 then
  begin
    lblstatus.Caption:='Kontakt beendet';
    btnabmelden.visible:=true;
    btnPauseBeginn.visible:=true;
    btnObjektBeginn.visible:=true;
    btnKontaktBeginn.Visible:=true;
    btnAuftragBeginn.Visible:=true;
    btnProduktionBeginn.Visible:=true;
  end;

  if xdsScanScanArt.AsInteger=24 then
  begin
    lblstatus.Caption:='Auftrag: '+xdsScanAuftrag.AsString+' ('+xdsSCANArbeitArt.asstring+') '+xdsSCANInfos.asstring;
    btnAuftragEnde.Visible:=true;
  end;

  if xdsScanScanArt.AsInteger=25 then
  begin
    lblstatus.Caption:='Auftrag beendet';
    btnabmelden.visible:=true;
    btnPauseBeginn.visible:=true;
    btnObjektBeginn.visible:=true;
    btnKontaktBeginn.Visible:=true;
    btnAuftragBeginn.Visible:=true;
    btnProduktionBeginn.Visible:=true;
  end;

  if xdsScanScanArt.AsInteger=34 then
  begin
    lblstatus.Caption:='Produktion: '+xdsScanPAuftrag.AsString+' '+xdsSCANInfos.asstring;
    btnProduktionEnde.Visible:=true;
  end;

  if xdsScanScanArt.AsInteger=35 then
  begin
    lblstatus.Caption:='Produktion beendet';
    btnabmelden.visible:=true;
    btnPauseBeginn.visible:=true;
    btnObjektBeginn.visible:=true;
    btnKontaktBeginn.Visible:=true;
    btnAuftragBeginn.Visible:=true;
    btnProduktionBeginn.Visible:=true;
  end;

  if xdsScanScanArt.AsInteger=9 then
  begin
    lblstatus.Caption:='Sie haben sich für heute bereits abgemeldet';
    btnErneutAnmelden.Visible:=true;
  end;
  if xdsPZEEinstellungenZuordnungObjekt.AsInteger<>1 then btnObjektBeginn.Visible:=false;
  if xdsPZEEinstellungenZuordnungKontakt.AsInteger<>1 then btnKontaktBeginn.Visible:=false;
  if xdsPZEEinstellungenZuordnungAuftrag.AsInteger<>1 then btnAuftragBeginn.Visible:=false;
  if xdsPZEEinstellungenZuordnungProduktion.AsInteger<>1 then btnProduktionBeginn.Visible:=false;
  if xdsPZEEinstellungenPauseVorgabe.AsInteger=1 then btnPauseVorgabe.Visible:=btnPauseBeginn.Visible;

  if xdsScanScanBegin.Asdatetime>encodetime(fjstunde,fjminute,0,0) then
  begin
    btnanmelden.visible:=false;
    btnPauseBeginn.visible:=false;
    btnPauseEnde.visible:=false;
    btnObjektBeginn.visible:=false;
    btnObjektEnde.visible:=false;
    btnabmelden.visible:=false;
    btnErneutAnmelden.Visible:=false;
    btnKontaktBeginn.Visible:=false;
    btnKontaktEnde.Visible:=false;
    btnProduktionBeginn.Visible:=false;
    btnProduktionEnde.Visible:=false;
    btnAuftragBeginn.Visible:=false;
    btnAuftragEnde.Visible:=false;
    btnPauseVorgabe.Visible:=false;
    lblstatus.Caption:='Sie sind noch in einer Pause';
  end;
  //automatisch von bisheriger Tätigkeit abmelden w/Herkunft aus Auftrag

  if (PZE_AutoObjektnummer<>'') OR (PZE_AutoAuftragnummer<>'') then
  begin
     if xdsScanScanArt.AsInteger=24 then btnAuftragEndeClick(nil);
     if xdsscanscanart.AsInteger=14 then btnKontaktEndeClick(nil);
     if xdsscanscanart.AsInteger=2 then btnPauseEndeClick(nil);
     if xdsscanscanart.AsInteger=4 then btnObjektEndeClick(nil);
     if xdsScanScanArt.AsInteger=34 then btnProduktionEndeClick(nil);
  end;
  lblAutoObjekt.Caption:=PZE_AutoObjektnummer;
  lblAutoAuftrag.Caption:=PZE_AutoAuftragnummer;

end;

procedure TPZE.xdsScanAfterPost(DataSet: TDataSet);
begin
  if myDoApply=1 then xdsScan.ApplyUpdates;

end;

procedure TPZE.xdsScanNewRecord(DataSet: TDataSet);
begin
  xdsScanFAID.Value:=xdsSingleArbeitszeit.CurrentData;
  xdsSCANPersonalnummer.AsString:=Benutzerpersonalnummer;
  xdsScanScanDatumZeit.AsDateTime:=date+time;
  xdsSCANDatum.AsDateTime:=encodedate(ftjahr,ftmonat,fttag);
  xdsSCANScanArt.AsInteger:=myScanArt;
  xdsSCANScanBegin.AsDateTime:=encodetime(ftstunde,ftminute,0,0);
  xdsScanausgewertet.AsBoolean:=false;
  xdsScanAMS.AsFloat:=ftms;
  xdsScanObjektreferenz.AsString:=myObjektReferenz;
  xdsScanKundennummer.AsString:=myKontaktReferenz;
  xdsScanAuftrag.AsString:=myAuftragReferenz;
  xdsScanPAuftrag.AsString:=myProduktionReferenz;
  xdsScanStundenArt.AsString:=mystundenart;
  xdsScanArbeitArt.AsString:=myArbeitArt;
  xdsScanDauerMinuten.AsFloat:=0;
  xdsScanInfos.AsString:=myInfos;
  xdsScanKalkStundensatz.AsFloat:=0;
  xdsScanKalkKosten.AsFloat:=0;
  myObjektReferenz:='';
  myKontaktReferenz:='';
  myArbeitArt:='[-]';
  myProduktionReferenz:='';
  myAuftragReferenz:='';
  mystundenart:='[-]';
  myInfos:='';

  xdsscan.Post;
end;

procedure TPZE.xdsSingleArbeitszeitAfterOpen(DataSet: TDataSet);
begin
  if xdsSingleArbeitszeit.RecordCount<1 then
  begin
    showmessage('CadiaPZE scheint für Sie nicht eingerichtet zu sein, sprechen Sie bitte Ihren Administrator an');
  end
  else
  begin
    myPauseSoll:=xdsSingleArbeitszeitSollPause.AsDateTime;
    btnPauseVorgabe.Caption:='Pause FIX '+formatdatetime('hh:mm',myPauseSoll);
    xdsPauseFix.Close;
    xdsPauseFix.QueryString:='$filter=FAID eq '+ xdsSingleArbeitszeitID.AsString+' &$orderby=ScanDatumZeit,ams';
    xdsScan.Close;
    xdsscan.QueryString:='$filter=FAID eq '+ xdsSingleArbeitszeitID.AsString+' &$orderby=ScanDatumZeit,ams';
    xdsscan.load;
  end;
end;

procedure TPZE.xdsStundenartAfterOpen(DataSet: TDataSet);
begin
  lookupstundenart.Items.Clear;
  xdsStundenart.First;
  while not xdsstundenart.eof do
  begin
    lookupstundenart.Items.Add(xdsStundenartStundenArt.asstring);
    xdsstundenart.Next;
  end;

  xdsSingleArbeitszeit.Close;
  xdssingleArbeitszeit.QueryString:='$filter=(EintragsArt eq 0) AND (Personalnummer eq '+Benutzerpersonalnummer+') AND (Datum eq '+formatdatetime('yyyy-mm-dd',date)+')';
  xdsSingleArbeitszeit.load;
end;


procedure TPZE.kontaktsuche1;
var
  LFrm:TfrmKontaktsuche;
    procedure AfterCreate(AForm:TObject);
    var
      LForm:TfrmKontaktsuche;
    begin
      LForm:=(AForm as TfrmKontaktsuche);
      lform.Kontaktnummer:='';
      lform.weiterzuEinzelkontakt:=false;
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      if lfrm.Kontaktnummer<>'' then
      begin
        myKontaktReferenz:=lfrm.kontaktnummer;
        myInfos:=trim(lfrm.LUVorname+' '+lfrm.LUNachname);
        myDoApply:=0;
        myScanArt:=14;
        panelfunktionen.Visible:=false;
        panelArbeitsart.Visible:=true;
        lblauswahlinfo.Caption:=mykontaktreferenz+' '+myinfos;

      end;
      if lfrm.kontaktnummer='' then
      begin
        showmessage('Der Vorgang wird abgebrochen, da Sie keinen Kontakt ausgewählt haben');
      end;

    end;

  begin
  LFrm:=TfrmKontaktsuche.CreateNew(@AfterCreate);
 // LFrm.Popup:=true;
  LFrm.ShowModal(@AfterShowmodal);

  end;

procedure TPZE.kontaktsuche2;
var
  LFrm:TfrmKontaktNummerSuche;
    procedure AfterCreate(AForm:TObject);
    var
      LForm:TfrmKontaktNummerSuche;
    begin
      LForm:=(AForm as TfrmKontaktNummerSuche);
      lform.Kontaktnummer:='';
      lform.weiterzuEinzelkontakt:=false;
    end;

    procedure AfterShowmodal(Avalue:TModalResult);
    begin
      if lfrm.Kontaktnummer<>'' then
      begin
        myKontaktReferenz:=lfrm.kontaktnummer;
        myInfos:=trim(lfrm.LUVorname+' '+lfrm.LUNachname);
        myDoApply:=0;
        myScanArt:=14;
        panelfunktionen.Visible:=false;
        panelArbeitsart.Visible:=true;
        lblauswahlinfo.Caption:=mykontaktreferenz+' '+myinfos;

      end;
      if lfrm.kontaktnummer='' then
      begin
        showmessage('Der Vorgang wird abgebrochen, da Sie keinen Kontakt ausgewählt haben');
      end;

    end;

  begin
  LFrm:=TfrmKontaktNummerSuche.CreateNew(@AfterCreate);
 // LFrm.Popup:=true;
  LFrm.ShowModal(@AfterShowmodal);

  end;

procedure TPZE.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lblstatus := TLabel.Create(Self);
  lblPInfo := TLabel.Create(Self);
  WebDBLabel2 := TDBLabel.Create(Self);
  lblAutoObjekt := TLabel.Create(Self);
  lblAutoAuftrag := TLabel.Create(Self);
  panelfunktionen := TPanel.Create(Self);
  btnAnmelden := TButton.Create(Self);
  btnPauseBeginn := TButton.Create(Self);
  btnPauseEnde := TButton.Create(Self);
  btnAbmelden := TButton.Create(Self);
  btnObjektBeginn := TButton.Create(Self);
  btnObjektEnde := TButton.Create(Self);
  btnErneutAnmelden := TButton.Create(Self);
  btnKontaktBeginn := TButton.Create(Self);
  btnKontaktEnde := TButton.Create(Self);
  btnAuftragBeginn := TButton.Create(Self);
  btnAuftragEnde := TButton.Create(Self);
  btnProduktionBeginn := TButton.Create(Self);
  btnProduktionEnde := TButton.Create(Self);
  btnPauseVorgabe := TButton.Create(Self);
  Container1 := THTMLContainer.Create(Self);
  Container2 := THTMLContainer.Create(Self);
  btnzurueck := TButton.Create(Self);
  TC := TTableControl.Create(Self);
  panelArbeitsart := TPanel.Create(Self);
  lblauswahlinfo := TLabel.Create(Self);
  radioarbeitsart := TRadioGroup.Create(Self);
  btnOK := TButton.Create(Self);
  btnAbbrechen := TButton.Create(Self);
  panelstundenart := TPanel.Create(Self);
  lblauswahlobjekt := TLabel.Create(Self);
  btnObjektOK := TButton.Create(Self);
  btnObjektAbbrechen := TButton.Create(Self);
  lookupstundenart := TComboBox.Create(Self);
  xdsSingleArbeitszeit := TXDataWebDataSet.Create(Self);
  xdsSingleArbeitszeitID := TStringField.Create(Self);
  xdsSingleArbeitszeitPersonalnummer := TIntegerField.Create(Self);
  xdsSingleArbeitszeitDatum := TDateTimeField.Create(Self);
  xdsSingleArbeitszeitEintragsArt := TIntegerField.Create(Self);
  xdsSingleArbeitszeitSollPause := TDateTimeField.Create(Self);
  sourceSingleArbeitszeit := TDataSource.Create(Self);
  xdsScan := TXDataWebDataSet.Create(Self);
  xdsScanPersonalnummer := TIntegerField.Create(Self);
  xdsScanScanDatumZeit := TDateTimeField.Create(Self);
  xdsScanDatum := TDateTimeField.Create(Self);
  xdsScanScanArt := TIntegerField.Create(Self);
  xdsScanObjektreferenz := TStringField.Create(Self);
  xdsScanScanBegin := TDateTimeField.Create(Self);
  xdsScanScanEnde := TDateTimeField.Create(Self);
  xdsScanausgewertet := TBooleanField.Create(Self);
  xdsScanAMS := TFloatField.Create(Self);
  xdsScanStundenArt := TStringField.Create(Self);
  xdsScanFAID := TXDataWebEntityField.Create(Self);
  xdsScanID := TStringField.Create(Self);
  xdsScanKundennummer := TStringField.Create(Self);
  xdsScanAuftrag := TStringField.Create(Self);
  xdsScanPAuftrag := TStringField.Create(Self);
  xdsScanArbeitArt := TStringField.Create(Self);
  xdsScanInfos := TStringField.Create(Self);
  xdsScanDauerMinuten := TFloatField.Create(Self);
  xdsScanKalkStundensatz := TFloatField.Create(Self);
  xdsScanKalkKosten := TFloatField.Create(Self);
  sourceScan := TDataSource.Create(Self);
  xdsPZEEinstellungen := TXDataWebDataSet.Create(Self);
  xdsPZEEinstellungenZuordnungObjekt := TIntegerField.Create(Self);
  xdsPZEEinstellungenZuordnungKontakt := TIntegerField.Create(Self);
  xdsPZEEinstellungenZuordnungAuftrag := TIntegerField.Create(Self);
  xdsPZEEinstellungenZuordnungProduktion := TIntegerField.Create(Self);
  xdsPZEEinstellungenAuswahlNurKontaktnummer := TIntegerField.Create(Self);
  xdsPZEEinstellungenPauseVorgabe := TIntegerField.Create(Self);
  sourcePZEEinstellungen := TDataSource.Create(Self);
  xdsStundenart := TXDataWebDataSet.Create(Self);
  xdsStundenartStundenArt := TStringField.Create(Self);
  sourceStundenart := TDataSource.Create(Self);
  xdsPauseFix := TXDataWebDataSet.Create(Self);
  xdsPauseFixFAID := TXDataWebEntityField.Create(Self);
  xdsPauseFixID := TStringField.Create(Self);
  xdsPauseFixPersonalnummer := TIntegerField.Create(Self);
  xdsPauseFixScanDatumZeit := TDateTimeField.Create(Self);
  xdsPauseFixDatum := TDateTimeField.Create(Self);
  xdsPauseFixScanArt := TIntegerField.Create(Self);
  xdsPauseFixObjektreferenz := TStringField.Create(Self);
  xdsPauseFixScanBegin := TDateTimeField.Create(Self);
  xdsPauseFixScanEnde := TDateTimeField.Create(Self);
  xdsPauseFixausgewertet := TBooleanField.Create(Self);
  xdsPauseFixAMS := TFloatField.Create(Self);
  xdsPauseFixStundenArt := TStringField.Create(Self);
  xdsPauseFixKundennummer := TStringField.Create(Self);
  xdsPauseFixAuftrag := TStringField.Create(Self);
  xdsPauseFixPAuftrag := TStringField.Create(Self);
  xdsPauseFixArbeitArt := TStringField.Create(Self);
  xdsPauseFixInfos := TStringField.Create(Self);
  xdsPauseFixDauerMinuten := TFloatField.Create(Self);
  xdsPauseFixKalkStundensatz := TFloatField.Create(Self);
  xdsPauseFixKalkKosten := TFloatField.Create(Self);

  lblstatus.BeforeLoadDFMValues;
  lblPInfo.BeforeLoadDFMValues;
  WebDBLabel2.BeforeLoadDFMValues;
  lblAutoObjekt.BeforeLoadDFMValues;
  lblAutoAuftrag.BeforeLoadDFMValues;
  panelfunktionen.BeforeLoadDFMValues;
  btnAnmelden.BeforeLoadDFMValues;
  btnPauseBeginn.BeforeLoadDFMValues;
  btnPauseEnde.BeforeLoadDFMValues;
  btnAbmelden.BeforeLoadDFMValues;
  btnObjektBeginn.BeforeLoadDFMValues;
  btnObjektEnde.BeforeLoadDFMValues;
  btnErneutAnmelden.BeforeLoadDFMValues;
  btnKontaktBeginn.BeforeLoadDFMValues;
  btnKontaktEnde.BeforeLoadDFMValues;
  btnAuftragBeginn.BeforeLoadDFMValues;
  btnAuftragEnde.BeforeLoadDFMValues;
  btnProduktionBeginn.BeforeLoadDFMValues;
  btnProduktionEnde.BeforeLoadDFMValues;
  btnPauseVorgabe.BeforeLoadDFMValues;
  Container1.BeforeLoadDFMValues;
  Container2.BeforeLoadDFMValues;
  btnzurueck.BeforeLoadDFMValues;
  TC.BeforeLoadDFMValues;
  panelArbeitsart.BeforeLoadDFMValues;
  lblauswahlinfo.BeforeLoadDFMValues;
  radioarbeitsart.BeforeLoadDFMValues;
  btnOK.BeforeLoadDFMValues;
  btnAbbrechen.BeforeLoadDFMValues;
  panelstundenart.BeforeLoadDFMValues;
  lblauswahlobjekt.BeforeLoadDFMValues;
  btnObjektOK.BeforeLoadDFMValues;
  btnObjektAbbrechen.BeforeLoadDFMValues;
  lookupstundenart.BeforeLoadDFMValues;
  xdsSingleArbeitszeit.BeforeLoadDFMValues;
  xdsSingleArbeitszeitID.BeforeLoadDFMValues;
  xdsSingleArbeitszeitPersonalnummer.BeforeLoadDFMValues;
  xdsSingleArbeitszeitDatum.BeforeLoadDFMValues;
  xdsSingleArbeitszeitEintragsArt.BeforeLoadDFMValues;
  xdsSingleArbeitszeitSollPause.BeforeLoadDFMValues;
  sourceSingleArbeitszeit.BeforeLoadDFMValues;
  xdsScan.BeforeLoadDFMValues;
  xdsScanPersonalnummer.BeforeLoadDFMValues;
  xdsScanScanDatumZeit.BeforeLoadDFMValues;
  xdsScanDatum.BeforeLoadDFMValues;
  xdsScanScanArt.BeforeLoadDFMValues;
  xdsScanObjektreferenz.BeforeLoadDFMValues;
  xdsScanScanBegin.BeforeLoadDFMValues;
  xdsScanScanEnde.BeforeLoadDFMValues;
  xdsScanausgewertet.BeforeLoadDFMValues;
  xdsScanAMS.BeforeLoadDFMValues;
  xdsScanStundenArt.BeforeLoadDFMValues;
  xdsScanFAID.BeforeLoadDFMValues;
  xdsScanID.BeforeLoadDFMValues;
  xdsScanKundennummer.BeforeLoadDFMValues;
  xdsScanAuftrag.BeforeLoadDFMValues;
  xdsScanPAuftrag.BeforeLoadDFMValues;
  xdsScanArbeitArt.BeforeLoadDFMValues;
  xdsScanInfos.BeforeLoadDFMValues;
  xdsScanDauerMinuten.BeforeLoadDFMValues;
  xdsScanKalkStundensatz.BeforeLoadDFMValues;
  xdsScanKalkKosten.BeforeLoadDFMValues;
  sourceScan.BeforeLoadDFMValues;
  xdsPZEEinstellungen.BeforeLoadDFMValues;
  xdsPZEEinstellungenZuordnungObjekt.BeforeLoadDFMValues;
  xdsPZEEinstellungenZuordnungKontakt.BeforeLoadDFMValues;
  xdsPZEEinstellungenZuordnungAuftrag.BeforeLoadDFMValues;
  xdsPZEEinstellungenZuordnungProduktion.BeforeLoadDFMValues;
  xdsPZEEinstellungenAuswahlNurKontaktnummer.BeforeLoadDFMValues;
  xdsPZEEinstellungenPauseVorgabe.BeforeLoadDFMValues;
  sourcePZEEinstellungen.BeforeLoadDFMValues;
  xdsStundenart.BeforeLoadDFMValues;
  xdsStundenartStundenArt.BeforeLoadDFMValues;
  sourceStundenart.BeforeLoadDFMValues;
  xdsPauseFix.BeforeLoadDFMValues;
  xdsPauseFixFAID.BeforeLoadDFMValues;
  xdsPauseFixID.BeforeLoadDFMValues;
  xdsPauseFixPersonalnummer.BeforeLoadDFMValues;
  xdsPauseFixScanDatumZeit.BeforeLoadDFMValues;
  xdsPauseFixDatum.BeforeLoadDFMValues;
  xdsPauseFixScanArt.BeforeLoadDFMValues;
  xdsPauseFixObjektreferenz.BeforeLoadDFMValues;
  xdsPauseFixScanBegin.BeforeLoadDFMValues;
  xdsPauseFixScanEnde.BeforeLoadDFMValues;
  xdsPauseFixausgewertet.BeforeLoadDFMValues;
  xdsPauseFixAMS.BeforeLoadDFMValues;
  xdsPauseFixStundenArt.BeforeLoadDFMValues;
  xdsPauseFixKundennummer.BeforeLoadDFMValues;
  xdsPauseFixAuftrag.BeforeLoadDFMValues;
  xdsPauseFixPAuftrag.BeforeLoadDFMValues;
  xdsPauseFixArbeitArt.BeforeLoadDFMValues;
  xdsPauseFixInfos.BeforeLoadDFMValues;
  xdsPauseFixDauerMinuten.BeforeLoadDFMValues;
  xdsPauseFixKalkStundensatz.BeforeLoadDFMValues;
  xdsPauseFixKalkKosten.BeforeLoadDFMValues;
  try
    Name := 'PZE';
    Width := 400;
    Height := 574;
    Caption := 'PZE';
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    SetEvent(Self, 'OnShow', 'WebFormShow');
    lblstatus.SetParentComponent(Self);
    lblstatus.Name := 'lblstatus';
    lblstatus.Left := 8;
    lblstatus.Top := 125;
    lblstatus.Width := 44;
    lblstatus.Height := 15;
    lblstatus.Caption := 'lblstatus';
    lblstatus.ElementClassName := 'h6 text-primary m-1';
    lblstatus.ElementFont := efCSS;
    lblstatus.ElementPosition := epIgnore;
    lblstatus.HeightStyle := ssAuto;
    lblstatus.HeightPercent := 100.000000000000000000;
    lblstatus.WidthStyle := ssAuto;
    lblstatus.WidthPercent := 100.000000000000000000;
    lblPInfo.SetParentComponent(Self);
    lblPInfo.Name := 'lblPInfo';
    lblPInfo.AlignWithMargins := True;
    lblPInfo.Left := -2;
    lblPInfo.Top := 144;
    lblPInfo.Width := 41;
    lblPInfo.Height := 15;
    lblPInfo.Alignment := taCenter;
    lblPInfo.Caption := 'lblPInfo';
    lblPInfo.ElementClassName := 'h6 text-primary m-1';
    lblPInfo.ElementFont := efCSS;
    lblPInfo.ElementPosition := epIgnore;
    lblPInfo.HeightStyle := ssAuto;
    lblPInfo.HeightPercent := 100.000000000000000000;
    lblPInfo.WidthStyle := ssAuto;
    lblPInfo.WidthPercent := 100.000000000000000000;
    WebDBLabel2.SetParentComponent(Self);
    WebDBLabel2.Name := 'WebDBLabel2';
    WebDBLabel2.AlignWithMargins := True;
    WebDBLabel2.Left := 11;
    WebDBLabel2.Top := 160;
    WebDBLabel2.Width := 73;
    WebDBLabel2.Height := 15;
    WebDBLabel2.Caption := 'WebDBLabel2';
    WebDBLabel2.ElementClassName := 'h6 text-primary m-1';
    WebDBLabel2.ElementFont := efCSS;
    WebDBLabel2.ElementPosition := epIgnore;
    WebDBLabel2.HeightPercent := 100.000000000000000000;
    WebDBLabel2.HTMLType := tP;
    WebDBLabel2.WidthStyle := ssAuto;
    WebDBLabel2.WidthPercent := 100.000000000000000000;
    WebDBLabel2.DataField := 'Datum';
    WebDBLabel2.DataSource := sourceSingleArbeitszeit;
    lblAutoObjekt.SetParentComponent(Self);
    lblAutoObjekt.Name := 'lblAutoObjekt';
    lblAutoObjekt.Left := 288;
    lblAutoObjekt.Top := 485;
    lblAutoObjekt.Width := 44;
    lblAutoObjekt.Height := 15;
    lblAutoObjekt.Caption := 'lblstatus';
    lblAutoObjekt.ElementClassName := 'h6 text-primary m-1';
    lblAutoObjekt.ElementFont := efCSS;
    lblAutoObjekt.ElementPosition := epIgnore;
    lblAutoObjekt.HeightStyle := ssAuto;
    lblAutoObjekt.HeightPercent := 100.000000000000000000;
    lblAutoObjekt.WidthStyle := ssAuto;
    lblAutoObjekt.WidthPercent := 100.000000000000000000;
    lblAutoAuftrag.SetParentComponent(Self);
    lblAutoAuftrag.Name := 'lblAutoAuftrag';
    lblAutoAuftrag.Left := 288;
    lblAutoAuftrag.Top := 504;
    lblAutoAuftrag.Width := 44;
    lblAutoAuftrag.Height := 15;
    lblAutoAuftrag.Caption := 'lblstatus';
    lblAutoAuftrag.ElementClassName := 'h6 text-primary m-1';
    lblAutoAuftrag.ElementFont := efCSS;
    lblAutoAuftrag.ElementPosition := epIgnore;
    lblAutoAuftrag.HeightStyle := ssAuto;
    lblAutoAuftrag.HeightPercent := 100.000000000000000000;
    lblAutoAuftrag.WidthStyle := ssAuto;
    lblAutoAuftrag.WidthPercent := 100.000000000000000000;
    panelfunktionen.SetParentComponent(Self);
    panelfunktionen.Name := 'panelfunktionen';
    panelfunktionen.Left := 0;
    panelfunktionen.Top := 179;
    panelfunktionen.Width := 257;
    panelfunktionen.Height := 300;
    panelfunktionen.ElementClassName := 'card m-1 border-info';
    panelfunktionen.Caption := 'panelfunktionen';
    panelfunktionen.ChildOrder := 9;
    panelfunktionen.Color := 8340248;
    panelfunktionen.ElementFont := efCSS;
    panelfunktionen.ElementPosition := epIgnore;
    panelfunktionen.ShowCaption := False;
    panelfunktionen.TabOrder := 0;
    btnAnmelden.SetParentComponent(panelfunktionen);
    btnAnmelden.Name := 'btnAnmelden';
    btnAnmelden.AlignWithMargins := True;
    btnAnmelden.Left := 3;
    btnAnmelden.Top := 3;
    btnAnmelden.Width := 251;
    btnAnmelden.Height := 40;
    btnAnmelden.Align := alTop;
    btnAnmelden.Caption := 'Anmelden';
    btnAnmelden.ChildOrder := 7;
    btnAnmelden.ElementClassName := 'btn btn-info btn-sm text-center';
    btnAnmelden.ElementFont := efCSS;
    btnAnmelden.HeightStyle := ssAuto;
    btnAnmelden.HeightPercent := 100.000000000000000000;
    btnAnmelden.WidthPercent := 100.000000000000000000;
    SetEvent(btnAnmelden, Self, 'OnClick', 'btnAnmeldenClick');
    btnPauseBeginn.SetParentComponent(panelfunktionen);
    btnPauseBeginn.Name := 'btnPauseBeginn';
    btnPauseBeginn.AlignWithMargins := True;
    btnPauseBeginn.Left := 3;
    btnPauseBeginn.Top := 95;
    btnPauseBeginn.Width := 251;
    btnPauseBeginn.Height := 40;
    btnPauseBeginn.Align := alTop;
    btnPauseBeginn.Caption := 'Pause';
    btnPauseBeginn.ChildOrder := 9;
    btnPauseBeginn.ElementClassName := 'btn btn-info btn-sm text-center';
    btnPauseBeginn.ElementFont := efCSS;
    btnPauseBeginn.HeightStyle := ssAuto;
    btnPauseBeginn.HeightPercent := 100.000000000000000000;
    btnPauseBeginn.WidthPercent := 100.000000000000000000;
    SetEvent(btnPauseBeginn, Self, 'OnClick', 'btnPauseBeginnClick');
    btnPauseEnde.SetParentComponent(panelfunktionen);
    btnPauseEnde.Name := 'btnPauseEnde';
    btnPauseEnde.AlignWithMargins := True;
    btnPauseEnde.Left := 3;
    btnPauseEnde.Top := 141;
    btnPauseEnde.Width := 251;
    btnPauseEnde.Height := 40;
    btnPauseEnde.Align := alTop;
    btnPauseEnde.Caption := 'Pause Ende';
    btnPauseEnde.ChildOrder := 10;
    btnPauseEnde.ElementClassName := 'btn btn-info btn-sm text-center';
    btnPauseEnde.ElementFont := efCSS;
    btnPauseEnde.HeightStyle := ssAuto;
    btnPauseEnde.HeightPercent := 100.000000000000000000;
    btnPauseEnde.WidthPercent := 100.000000000000000000;
    SetEvent(btnPauseEnde, Self, 'OnClick', 'btnPauseEndeClick');
    btnAbmelden.SetParentComponent(panelfunktionen);
    btnAbmelden.Name := 'btnAbmelden';
    btnAbmelden.AlignWithMargins := True;
    btnAbmelden.Left := 3;
    btnAbmelden.Top := 555;
    btnAbmelden.Width := 251;
    btnAbmelden.Height := 40;
    btnAbmelden.Align := alTop;
    btnAbmelden.Caption := 'Abmelden';
    btnAbmelden.ChildOrder := 11;
    btnAbmelden.ElementClassName := 'btn btn-info btn-sm text-center';
    btnAbmelden.ElementFont := efCSS;
    btnAbmelden.HeightStyle := ssAuto;
    btnAbmelden.HeightPercent := 100.000000000000000000;
    btnAbmelden.WidthPercent := 100.000000000000000000;
    SetEvent(btnAbmelden, Self, 'OnClick', 'btnAbmeldenClick');
    btnObjektBeginn.SetParentComponent(panelfunktionen);
    btnObjektBeginn.Name := 'btnObjektBeginn';
    btnObjektBeginn.AlignWithMargins := True;
    btnObjektBeginn.Left := 3;
    btnObjektBeginn.Top := 187;
    btnObjektBeginn.Width := 251;
    btnObjektBeginn.Height := 40;
    btnObjektBeginn.Align := alTop;
    btnObjektBeginn.Caption := 'Objekt';
    btnObjektBeginn.ChildOrder := 13;
    btnObjektBeginn.ElementClassName := 'btn btn-info btn-sm text-center';
    btnObjektBeginn.ElementFont := efCSS;
    btnObjektBeginn.HeightStyle := ssAuto;
    btnObjektBeginn.HeightPercent := 100.000000000000000000;
    btnObjektBeginn.WidthPercent := 100.000000000000000000;
    SetEvent(btnObjektBeginn, Self, 'OnClick', 'btnObjektBeginnClick');
    btnObjektEnde.SetParentComponent(panelfunktionen);
    btnObjektEnde.Name := 'btnObjektEnde';
    btnObjektEnde.AlignWithMargins := True;
    btnObjektEnde.Left := 3;
    btnObjektEnde.Top := 509;
    btnObjektEnde.Width := 251;
    btnObjektEnde.Height := 40;
    btnObjektEnde.Align := alTop;
    btnObjektEnde.Caption := 'Objekt Ende';
    btnObjektEnde.ChildOrder := 14;
    btnObjektEnde.ElementClassName := 'btn btn-info btn-sm text-center';
    btnObjektEnde.ElementFont := efCSS;
    btnObjektEnde.HeightStyle := ssAuto;
    btnObjektEnde.HeightPercent := 100.000000000000000000;
    btnObjektEnde.WidthPercent := 100.000000000000000000;
    SetEvent(btnObjektEnde, Self, 'OnClick', 'btnObjektEndeClick');
    btnErneutAnmelden.SetParentComponent(panelfunktionen);
    btnErneutAnmelden.Name := 'btnErneutAnmelden';
    btnErneutAnmelden.AlignWithMargins := True;
    btnErneutAnmelden.Left := 3;
    btnErneutAnmelden.Top := 601;
    btnErneutAnmelden.Width := 251;
    btnErneutAnmelden.Height := 40;
    btnErneutAnmelden.Align := alTop;
    btnErneutAnmelden.Caption := 'erneut anmelden';
    btnErneutAnmelden.ChildOrder := 12;
    btnErneutAnmelden.ElementClassName := 'btn btn-info btn-sm text-center';
    btnErneutAnmelden.ElementFont := efCSS;
    btnErneutAnmelden.HeightStyle := ssAuto;
    btnErneutAnmelden.HeightPercent := 100.000000000000000000;
    btnErneutAnmelden.WidthPercent := 100.000000000000000000;
    SetEvent(btnErneutAnmelden, Self, 'OnClick', 'btnErneutAnmeldenClick');
    btnKontaktBeginn.SetParentComponent(panelfunktionen);
    btnKontaktBeginn.Name := 'btnKontaktBeginn';
    btnKontaktBeginn.AlignWithMargins := True;
    btnKontaktBeginn.Left := 3;
    btnKontaktBeginn.Top := 233;
    btnKontaktBeginn.Width := 251;
    btnKontaktBeginn.Height := 40;
    btnKontaktBeginn.Align := alTop;
    btnKontaktBeginn.Caption := 'Kontakt';
    btnKontaktBeginn.ChildOrder := 13;
    btnKontaktBeginn.ElementClassName := 'btn btn-info btn-sm text-center';
    btnKontaktBeginn.ElementFont := efCSS;
    btnKontaktBeginn.HeightStyle := ssAuto;
    btnKontaktBeginn.HeightPercent := 100.000000000000000000;
    btnKontaktBeginn.WidthPercent := 100.000000000000000000;
    SetEvent(btnKontaktBeginn, Self, 'OnClick', 'btnKontaktBeginnClick');
    btnKontaktEnde.SetParentComponent(panelfunktionen);
    btnKontaktEnde.Name := 'btnKontaktEnde';
    btnKontaktEnde.AlignWithMargins := True;
    btnKontaktEnde.Left := 3;
    btnKontaktEnde.Top := 463;
    btnKontaktEnde.Width := 251;
    btnKontaktEnde.Height := 40;
    btnKontaktEnde.Align := alTop;
    btnKontaktEnde.Caption := 'Kontakt Ende';
    btnKontaktEnde.ChildOrder := 14;
    btnKontaktEnde.ElementClassName := 'btn btn-info btn-sm text-center';
    btnKontaktEnde.ElementFont := efCSS;
    btnKontaktEnde.HeightStyle := ssAuto;
    btnKontaktEnde.HeightPercent := 100.000000000000000000;
    btnKontaktEnde.WidthPercent := 100.000000000000000000;
    SetEvent(btnKontaktEnde, Self, 'OnClick', 'btnKontaktEndeClick');
    btnAuftragBeginn.SetParentComponent(panelfunktionen);
    btnAuftragBeginn.Name := 'btnAuftragBeginn';
    btnAuftragBeginn.AlignWithMargins := True;
    btnAuftragBeginn.Left := 3;
    btnAuftragBeginn.Top := 279;
    btnAuftragBeginn.Width := 251;
    btnAuftragBeginn.Height := 40;
    btnAuftragBeginn.Align := alTop;
    btnAuftragBeginn.Caption := 'Auftrag';
    btnAuftragBeginn.ChildOrder := 13;
    btnAuftragBeginn.ElementClassName := 'btn btn-info btn-sm text-center';
    btnAuftragBeginn.ElementFont := efCSS;
    btnAuftragBeginn.HeightStyle := ssAuto;
    btnAuftragBeginn.HeightPercent := 100.000000000000000000;
    btnAuftragBeginn.WidthPercent := 100.000000000000000000;
    SetEvent(btnAuftragBeginn, Self, 'OnClick', 'btnAuftragBeginnClick');
    btnAuftragEnde.SetParentComponent(panelfunktionen);
    btnAuftragEnde.Name := 'btnAuftragEnde';
    btnAuftragEnde.AlignWithMargins := True;
    btnAuftragEnde.Left := 3;
    btnAuftragEnde.Top := 417;
    btnAuftragEnde.Width := 251;
    btnAuftragEnde.Height := 40;
    btnAuftragEnde.Align := alTop;
    btnAuftragEnde.Caption := 'Auftrag Ende';
    btnAuftragEnde.ChildOrder := 14;
    btnAuftragEnde.ElementClassName := 'btn btn-info btn-sm text-center';
    btnAuftragEnde.ElementFont := efCSS;
    btnAuftragEnde.HeightStyle := ssAuto;
    btnAuftragEnde.HeightPercent := 100.000000000000000000;
    btnAuftragEnde.WidthPercent := 100.000000000000000000;
    SetEvent(btnAuftragEnde, Self, 'OnClick', 'btnAuftragEndeClick');
    btnProduktionBeginn.SetParentComponent(panelfunktionen);
    btnProduktionBeginn.Name := 'btnProduktionBeginn';
    btnProduktionBeginn.AlignWithMargins := True;
    btnProduktionBeginn.Left := 3;
    btnProduktionBeginn.Top := 325;
    btnProduktionBeginn.Width := 251;
    btnProduktionBeginn.Height := 40;
    btnProduktionBeginn.Align := alTop;
    btnProduktionBeginn.Caption := 'Produktion';
    btnProduktionBeginn.ChildOrder := 13;
    btnProduktionBeginn.ElementClassName := 'btn btn-info btn-sm text-center';
    btnProduktionBeginn.ElementFont := efCSS;
    btnProduktionBeginn.HeightStyle := ssAuto;
    btnProduktionBeginn.HeightPercent := 100.000000000000000000;
    btnProduktionBeginn.WidthPercent := 100.000000000000000000;
    SetEvent(btnProduktionBeginn, Self, 'OnClick', 'btnProduktionBeginnClick');
    btnProduktionEnde.SetParentComponent(panelfunktionen);
    btnProduktionEnde.Name := 'btnProduktionEnde';
    btnProduktionEnde.AlignWithMargins := True;
    btnProduktionEnde.Left := 3;
    btnProduktionEnde.Top := 371;
    btnProduktionEnde.Width := 251;
    btnProduktionEnde.Height := 40;
    btnProduktionEnde.Align := alTop;
    btnProduktionEnde.Caption := 'Produktion Ende';
    btnProduktionEnde.ChildOrder := 14;
    btnProduktionEnde.ElementClassName := 'btn btn-info btn-sm text-center';
    btnProduktionEnde.ElementFont := efCSS;
    btnProduktionEnde.HeightStyle := ssAuto;
    btnProduktionEnde.HeightPercent := 100.000000000000000000;
    btnProduktionEnde.WidthPercent := 100.000000000000000000;
    SetEvent(btnProduktionEnde, Self, 'OnClick', 'btnProduktionEndeClick');
    btnPauseVorgabe.SetParentComponent(panelfunktionen);
    btnPauseVorgabe.Name := 'btnPauseVorgabe';
    btnPauseVorgabe.AlignWithMargins := True;
    btnPauseVorgabe.Left := 3;
    btnPauseVorgabe.Top := 49;
    btnPauseVorgabe.Width := 251;
    btnPauseVorgabe.Height := 40;
    btnPauseVorgabe.Align := alTop;
    btnPauseVorgabe.Caption := 'Pause';
    btnPauseVorgabe.ChildOrder := 9;
    btnPauseVorgabe.ElementClassName := 'btn btn-info btn-sm text-center';
    btnPauseVorgabe.ElementFont := efCSS;
    btnPauseVorgabe.HeightStyle := ssAuto;
    btnPauseVorgabe.HeightPercent := 100.000000000000000000;
    btnPauseVorgabe.WidthPercent := 100.000000000000000000;
    SetEvent(btnPauseVorgabe, Self, 'OnClick', 'btnPauseVorgabeClick');
    Container1.SetParentComponent(Self);
    Container1.Name := 'Container1';
    Container1.Left := 0;
    Container1.Top := 0;
    Container1.Width := 169;
    Container1.Height := 41;
    Container1.HeightStyle := ssAuto;
    Container1.WidthStyle := ssPercent;
    Container1.ElementFont := efCSS;
    Container1.ElementPosition := epIgnore;
    Container2.SetParentComponent(Self);
    Container2.Name := 'Container2';
    Container2.Left := 0;
    Container2.Top := 47;
    Container2.Width := 169;
    Container2.Height := 41;
    Container2.ElementClassName := 'col d-flex justify-content-center';
    Container2.HeightStyle := ssAuto;
    Container2.WidthStyle := ssAuto;
    Container2.ChildOrder := 1;
    Container2.ElementFont := efCSS;
    Container2.ElementPosition := epIgnore;
    btnzurueck.SetParentComponent(Self);
    btnzurueck.Name := 'btnzurueck';
    btnzurueck.Left := 0;
    btnzurueck.Top := 94;
    btnzurueck.Width := 96;
    btnzurueck.Height := 25;
    btnzurueck.Caption := '<< zur'#252'ck';
    btnzurueck.ChildOrder := 4;
    btnzurueck.ElementClassName := 'btn btn-info btn-sm m-1 text-left';
    btnzurueck.ElementFont := efCSS;
    btnzurueck.ElementPosition := epIgnore;
    btnzurueck.HeightStyle := ssAuto;
    btnzurueck.HeightPercent := 100.000000000000000000;
    btnzurueck.WidthStyle := ssAuto;
    btnzurueck.WidthPercent := 100.000000000000000000;
    SetEvent(btnzurueck, Self, 'OnClick', 'btnzurueckClick');
    TC.SetParentComponent(Self);
    TC.Name := 'TC';
    TC.Left := 0;
    TC.Top := 480;
    TC.Width := 247;
    TC.Height := 81;
    TC.ElementClassName := 'table table-sm table-hover table-bordered table-striped';
    TC.HeightStyle := ssAuto;
    TC.WidthStyle := ssPercent;
    TC.BorderColor := clSilver;
    TC.ChildOrder := 2;
    TC.ColHeader := False;
    TC.ElementHeaderClassName := 'table-info';
    TC.ElementPosition := epIgnore;
    TC.ElementTableClassName := 'table table-sm table-hover table-bordered table-striped';
    TC.Options.ScrollVertical := True;
    TC.WordWrap := True;
    TC.ColCount := 2;
    panelArbeitsart.SetParentComponent(Self);
    panelArbeitsart.Name := 'panelArbeitsart';
    panelArbeitsart.Left := 128;
    panelArbeitsart.Top := 182;
    panelArbeitsart.Width := 241;
    panelArbeitsart.Height := 195;
    panelArbeitsart.ElementClassName := 'card m-1 border-info';
    panelArbeitsart.HeightStyle := ssAuto;
    panelArbeitsart.Caption := 'panelArbeitsart';
    panelArbeitsart.ChildOrder := 8;
    panelArbeitsart.ElementBodyClassName := 'card-body';
    panelArbeitsart.ElementFont := efCSS;
    panelArbeitsart.ElementPosition := epIgnore;
    panelArbeitsart.ShowCaption := False;
    panelArbeitsart.TabOrder := 5;
    lblauswahlinfo.SetParentComponent(panelArbeitsart);
    lblauswahlinfo.Name := 'lblauswahlinfo';
    lblauswahlinfo.Left := 16;
    lblauswahlinfo.Top := 8;
    lblauswahlinfo.Width := 77;
    lblauswahlinfo.Height := 15;
    lblauswahlinfo.Caption := 'lblauswahlinfo';
    lblauswahlinfo.ElementLabelClassName := 'h6';
    lblauswahlinfo.ElementFont := efCSS;
    lblauswahlinfo.ElementPosition := epIgnore;
    lblauswahlinfo.HeightStyle := ssAuto;
    lblauswahlinfo.HeightPercent := 100.000000000000000000;
    lblauswahlinfo.WordWrap := True;
    lblauswahlinfo.WidthStyle := ssAuto;
    lblauswahlinfo.WidthPercent := 100.000000000000000000;
    radioarbeitsart.SetParentComponent(panelArbeitsart);
    radioarbeitsart.Name := 'radioarbeitsart';
    radioarbeitsart.Left := 40;
    radioarbeitsart.Top := 32;
    radioarbeitsart.Width := 160;
    radioarbeitsart.Height := 122;
    radioarbeitsart.ElementClassName := 'form-check';
    radioarbeitsart.HeightStyle := ssAuto;
    radioarbeitsart.WidthStyle := ssAuto;
    radioarbeitsart.Caption := 'Arbeitsart';
    radioarbeitsart.ChildOrder := 1;
    radioarbeitsart.Columns := 1;
    radioarbeitsart.ControlPosition := epIgnore;
    radioarbeitsart.ElementButtonClassName := 'form-check-input type=radio';
    radioarbeitsart.ElementGroupClassName := 'form-check type=radio';
    radioarbeitsart.ElementLabelClassName := 'form-check-label';
    radioarbeitsart.ElementFont := efCSS;
    radioarbeitsart.ElementPosition := epIgnore;
    radioarbeitsart.ItemIndex := 0;
    radioarbeitsart.Items.BeginUpdate;
    try
      radioarbeitsart.Items.Clear;
      radioarbeitsart.Items.Add('[-]');
      radioarbeitsart.Items.Add('Arbeitszeit');
      radioarbeitsart.Items.Add('Fahrzeit');
    finally
      radioarbeitsart.Items.EndUpdate;
    end;
    radioarbeitsart.Role := '';
    radioarbeitsart.TabOrder := 0;
    btnOK.SetParentComponent(panelArbeitsart);
    btnOK.Name := 'btnOK';
    btnOK.Left := 136;
    btnOK.Top := 160;
    btnOK.Width := 96;
    btnOK.Height := 25;
    btnOK.Caption := 'OK';
    btnOK.ChildOrder := 3;
    btnOK.ElementClassName := 'btn btn-info btn-sm m-2 text-center';
    btnOK.ElementFont := efCSS;
    btnOK.ElementPosition := epIgnore;
    btnOK.HeightStyle := ssAuto;
    btnOK.HeightPercent := 100.000000000000000000;
    btnOK.WidthPercent := 100.000000000000000000;
    SetEvent(btnOK, Self, 'OnClick', 'btnOKClick');
    btnAbbrechen.SetParentComponent(panelArbeitsart);
    btnAbbrechen.Name := 'btnAbbrechen';
    btnAbbrechen.Left := 16;
    btnAbbrechen.Top := 160;
    btnAbbrechen.Width := 96;
    btnAbbrechen.Height := 25;
    btnAbbrechen.Caption := 'Abbrechen';
    btnAbbrechen.ChildOrder := 2;
    btnAbbrechen.ElementClassName := 'btn btn-info btn-sm m-2 text-center';
    btnAbbrechen.ElementFont := efCSS;
    btnAbbrechen.ElementPosition := epIgnore;
    btnAbbrechen.HeightStyle := ssAuto;
    btnAbbrechen.HeightPercent := 100.000000000000000000;
    btnAbbrechen.WidthPercent := 100.000000000000000000;
    SetEvent(btnAbbrechen, Self, 'OnClick', 'btnAbbrechenClick');
    panelstundenart.SetParentComponent(Self);
    panelstundenart.Name := 'panelstundenart';
    panelstundenart.Left := 128;
    panelstundenart.Top := 27;
    panelstundenart.Width := 241;
    panelstundenart.Height := 195;
    panelstundenart.ElementClassName := 'card m-1 border-info';
    panelstundenart.HeightStyle := ssAuto;
    panelstundenart.Caption := 'panelArbeitsart';
    panelstundenart.ChildOrder := 8;
    panelstundenart.ElementBodyClassName := 'card-body';
    panelstundenart.ElementFont := efCSS;
    panelstundenart.ElementPosition := epIgnore;
    panelstundenart.ShowCaption := False;
    panelstundenart.TabOrder := 6;
    lblauswahlobjekt.SetParentComponent(panelstundenart);
    lblauswahlobjekt.Name := 'lblauswahlobjekt';
    lblauswahlobjekt.Left := 16;
    lblauswahlobjekt.Top := 8;
    lblauswahlobjekt.Width := 77;
    lblauswahlobjekt.Height := 15;
    lblauswahlobjekt.Caption := 'lblauswahlinfo';
    lblauswahlobjekt.ElementLabelClassName := 'h6';
    lblauswahlobjekt.ElementFont := efCSS;
    lblauswahlobjekt.ElementPosition := epIgnore;
    lblauswahlobjekt.HeightStyle := ssAuto;
    lblauswahlobjekt.HeightPercent := 100.000000000000000000;
    lblauswahlobjekt.WordWrap := True;
    lblauswahlobjekt.WidthStyle := ssAuto;
    lblauswahlobjekt.WidthPercent := 100.000000000000000000;
    btnObjektOK.SetParentComponent(panelstundenart);
    btnObjektOK.Name := 'btnObjektOK';
    btnObjektOK.Left := 136;
    btnObjektOK.Top := 160;
    btnObjektOK.Width := 96;
    btnObjektOK.Height := 25;
    btnObjektOK.Caption := 'OK';
    btnObjektOK.ChildOrder := 3;
    btnObjektOK.ElementClassName := 'btn btn-info btn-sm m-2 text-center';
    btnObjektOK.ElementFont := efCSS;
    btnObjektOK.ElementPosition := epIgnore;
    btnObjektOK.HeightStyle := ssAuto;
    btnObjektOK.HeightPercent := 100.000000000000000000;
    btnObjektOK.WidthPercent := 100.000000000000000000;
    SetEvent(btnObjektOK, Self, 'OnClick', 'btnObjektOKClick');
    btnObjektAbbrechen.SetParentComponent(panelstundenart);
    btnObjektAbbrechen.Name := 'btnObjektAbbrechen';
    btnObjektAbbrechen.Left := 16;
    btnObjektAbbrechen.Top := 160;
    btnObjektAbbrechen.Width := 96;
    btnObjektAbbrechen.Height := 25;
    btnObjektAbbrechen.Caption := 'Abbrechen';
    btnObjektAbbrechen.ChildOrder := 2;
    btnObjektAbbrechen.ElementClassName := 'btn btn-info btn-sm m-2 text-center';
    btnObjektAbbrechen.ElementFont := efCSS;
    btnObjektAbbrechen.ElementPosition := epIgnore;
    btnObjektAbbrechen.HeightStyle := ssAuto;
    btnObjektAbbrechen.HeightPercent := 100.000000000000000000;
    btnObjektAbbrechen.WidthPercent := 100.000000000000000000;
    SetEvent(btnObjektAbbrechen, Self, 'OnClick', 'btnObjektAbbrechenClick');
    lookupstundenart.SetParentComponent(panelstundenart);
    lookupstundenart.Name := 'lookupstundenart';
    lookupstundenart.Left := 40;
    lookupstundenart.Top := 56;
    lookupstundenart.Width := 177;
    lookupstundenart.Height := 23;
    lookupstundenart.ChildOrder := 1;
    lookupstundenart.ElementClassName := 'form-control w-75 m-1';
    lookupstundenart.ElementFont := efCSS;
    lookupstundenart.ElementPosition := epIgnore;
    lookupstundenart.HeightStyle := ssAuto;
    lookupstundenart.HeightPercent := 100.000000000000000000;
    lookupstundenart.Text := 'lookupstundenart';
    lookupstundenart.WidthPercent := 100.000000000000000000;
    lookupstundenart.ItemIndex := -1;
    xdsSingleArbeitszeit.SetParentComponent(Self);
    xdsSingleArbeitszeit.Name := 'xdsSingleArbeitszeit';
    xdsSingleArbeitszeit.AfterOpen := xdsSingleArbeitszeitAfterOpen;
    xdsSingleArbeitszeit.EntitySetName := 'PZE_Arbeitszeiten';
    xdsSingleArbeitszeit.Connection := DM2.XDataWebConnection1;
    xdsSingleArbeitszeit.Left := 112;
    xdsSingleArbeitszeit.Top := 16;
    xdsSingleArbeitszeitID.SetParentComponent(xdsSingleArbeitszeit);
    xdsSingleArbeitszeitID.Name := 'xdsSingleArbeitszeitID';
    xdsSingleArbeitszeitID.FieldName := 'ID';
    xdsSingleArbeitszeitID.Required := True;
    xdsSingleArbeitszeitID.Size := 38;
    xdsSingleArbeitszeitPersonalnummer.SetParentComponent(xdsSingleArbeitszeit);
    xdsSingleArbeitszeitPersonalnummer.Name := 'xdsSingleArbeitszeitPersonalnummer';
    xdsSingleArbeitszeitPersonalnummer.FieldName := 'Personalnummer';
    xdsSingleArbeitszeitPersonalnummer.Required := True;
    xdsSingleArbeitszeitDatum.SetParentComponent(xdsSingleArbeitszeit);
    xdsSingleArbeitszeitDatum.Name := 'xdsSingleArbeitszeitDatum';
    xdsSingleArbeitszeitDatum.FieldName := 'Datum';
    xdsSingleArbeitszeitDatum.Required := True;
    xdsSingleArbeitszeitDatum.DisplayFormat := 'DDD DD.MM.YYYY';
    xdsSingleArbeitszeitEintragsArt.SetParentComponent(xdsSingleArbeitszeit);
    xdsSingleArbeitszeitEintragsArt.Name := 'xdsSingleArbeitszeitEintragsArt';
    xdsSingleArbeitszeitEintragsArt.FieldName := 'EintragsArt';
    xdsSingleArbeitszeitEintragsArt.Required := True;
    xdsSingleArbeitszeitSollPause.SetParentComponent(xdsSingleArbeitszeit);
    xdsSingleArbeitszeitSollPause.Name := 'xdsSingleArbeitszeitSollPause';
    xdsSingleArbeitszeitSollPause.FieldName := 'SollPause';
    sourceSingleArbeitszeit.SetParentComponent(Self);
    sourceSingleArbeitszeit.Name := 'sourceSingleArbeitszeit';
    sourceSingleArbeitszeit.DataSet := xdsSingleArbeitszeit;
    sourceSingleArbeitszeit.Left := 32;
    sourceSingleArbeitszeit.Top := 16;
    xdsScan.SetParentComponent(Self);
    xdsScan.Name := 'xdsScan';
    xdsScan.AfterApplyUpdates := xdsScanAfterApplyUpdates;
    xdsScan.AfterOpen := xdsScanAfterOpen;
    xdsScan.AfterPost := xdsScanAfterPost;
    SetEvent(xdsScan, Self, 'OnNewRecord', 'xdsScanNewRecord');
    xdsScan.EntitySetName := 'PZE_ArbeitszeitenScan';
    xdsScan.Connection := DM2.XDataWebConnection1;
    xdsScan.Left := 112;
    xdsScan.Top := 64;
    xdsScanPersonalnummer.SetParentComponent(xdsScan);
    xdsScanPersonalnummer.Name := 'xdsScanPersonalnummer';
    xdsScanPersonalnummer.FieldName := 'Personalnummer';
    xdsScanScanDatumZeit.SetParentComponent(xdsScan);
    xdsScanScanDatumZeit.Name := 'xdsScanScanDatumZeit';
    xdsScanScanDatumZeit.FieldName := 'ScanDatumZeit';
    xdsScanScanDatumZeit.DisplayFormat := 'DD.MM.YYYY hh.mm.ss';
    xdsScanDatum.SetParentComponent(xdsScan);
    xdsScanDatum.Name := 'xdsScanDatum';
    xdsScanDatum.FieldName := 'Datum';
    xdsScanScanArt.SetParentComponent(xdsScan);
    xdsScanScanArt.Name := 'xdsScanScanArt';
    xdsScanScanArt.FieldName := 'ScanArt';
    xdsScanObjektreferenz.SetParentComponent(xdsScan);
    xdsScanObjektreferenz.Name := 'xdsScanObjektreferenz';
    xdsScanObjektreferenz.FieldName := 'Objektreferenz';
    xdsScanObjektreferenz.Size := 13;
    xdsScanScanBegin.SetParentComponent(xdsScan);
    xdsScanScanBegin.Name := 'xdsScanScanBegin';
    xdsScanScanBegin.FieldName := 'ScanBegin';
    xdsScanScanBegin.DisplayFormat := 'hh:mm';
    xdsScanScanEnde.SetParentComponent(xdsScan);
    xdsScanScanEnde.Name := 'xdsScanScanEnde';
    xdsScanScanEnde.FieldName := 'ScanEnde';
    xdsScanScanEnde.DisplayFormat := 'hh:mm';
    xdsScanausgewertet.SetParentComponent(xdsScan);
    xdsScanausgewertet.Name := 'xdsScanausgewertet';
    xdsScanausgewertet.FieldName := 'ausgewertet';
    xdsScanAMS.SetParentComponent(xdsScan);
    xdsScanAMS.Name := 'xdsScanAMS';
    xdsScanAMS.FieldName := 'AMS';
    xdsScanStundenArt.SetParentComponent(xdsScan);
    xdsScanStundenArt.Name := 'xdsScanStundenArt';
    xdsScanStundenArt.FieldName := 'StundenArt';
    xdsScanStundenArt.Size := 50;
    xdsScanFAID.SetParentComponent(xdsScan);
    xdsScanFAID.Name := 'xdsScanFAID';
    xdsScanFAID.FieldName := 'FAID';
    xdsScanID.SetParentComponent(xdsScan);
    xdsScanID.Name := 'xdsScanID';
    xdsScanID.FieldName := 'ID';
    xdsScanID.Size := 38;
    xdsScanKundennummer.SetParentComponent(xdsScan);
    xdsScanKundennummer.Name := 'xdsScanKundennummer';
    xdsScanKundennummer.FieldName := 'Kundennummer';
    xdsScanKundennummer.Size := 13;
    xdsScanAuftrag.SetParentComponent(xdsScan);
    xdsScanAuftrag.Name := 'xdsScanAuftrag';
    xdsScanAuftrag.FieldName := 'Auftrag';
    xdsScanAuftrag.Size := 10;
    xdsScanPAuftrag.SetParentComponent(xdsScan);
    xdsScanPAuftrag.Name := 'xdsScanPAuftrag';
    xdsScanPAuftrag.FieldName := 'PAuftrag';
    xdsScanPAuftrag.Size := 10;
    xdsScanArbeitArt.SetParentComponent(xdsScan);
    xdsScanArbeitArt.Name := 'xdsScanArbeitArt';
    xdsScanArbeitArt.FieldName := 'ArbeitArt';
    xdsScanInfos.SetParentComponent(xdsScan);
    xdsScanInfos.Name := 'xdsScanInfos';
    xdsScanInfos.FieldName := 'Infos';
    xdsScanInfos.Size := 255;
    xdsScanDauerMinuten.SetParentComponent(xdsScan);
    xdsScanDauerMinuten.Name := 'xdsScanDauerMinuten';
    xdsScanDauerMinuten.FieldName := 'DauerMinuten';
    xdsScanKalkStundensatz.SetParentComponent(xdsScan);
    xdsScanKalkStundensatz.Name := 'xdsScanKalkStundensatz';
    xdsScanKalkStundensatz.FieldName := 'KalkStundensatz';
    xdsScanKalkKosten.SetParentComponent(xdsScan);
    xdsScanKalkKosten.Name := 'xdsScanKalkKosten';
    xdsScanKalkKosten.FieldName := 'KalkKosten';
    sourceScan.SetParentComponent(Self);
    sourceScan.Name := 'sourceScan';
    sourceScan.DataSet := xdsScan;
    sourceScan.Left := 32;
    sourceScan.Top := 56;
    xdsPZEEinstellungen.SetParentComponent(Self);
    xdsPZEEinstellungen.Name := 'xdsPZEEinstellungen';
    xdsPZEEinstellungen.AfterOpen := xdsPZEEinstellungenAfterOpen;
    xdsPZEEinstellungen.EntitySetName := 'PZE_Einstellungen';
    xdsPZEEinstellungen.Connection := DM2.XDataWebConnection1;
    xdsPZEEinstellungen.Left := 184;
    xdsPZEEinstellungen.Top := 128;
    xdsPZEEinstellungenZuordnungObjekt.SetParentComponent(xdsPZEEinstellungen);
    xdsPZEEinstellungenZuordnungObjekt.Name := 'xdsPZEEinstellungenZuordnungObjekt';
    xdsPZEEinstellungenZuordnungObjekt.FieldName := 'ZuordnungObjekt';
    xdsPZEEinstellungenZuordnungKontakt.SetParentComponent(xdsPZEEinstellungen);
    xdsPZEEinstellungenZuordnungKontakt.Name := 'xdsPZEEinstellungenZuordnungKontakt';
    xdsPZEEinstellungenZuordnungKontakt.FieldName := 'ZuordnungKontakt';
    xdsPZEEinstellungenZuordnungAuftrag.SetParentComponent(xdsPZEEinstellungen);
    xdsPZEEinstellungenZuordnungAuftrag.Name := 'xdsPZEEinstellungenZuordnungAuftrag';
    xdsPZEEinstellungenZuordnungAuftrag.FieldName := 'ZuordnungAuftrag';
    xdsPZEEinstellungenZuordnungProduktion.SetParentComponent(xdsPZEEinstellungen);
    xdsPZEEinstellungenZuordnungProduktion.Name := 'xdsPZEEinstellungenZuordnungProduktion';
    xdsPZEEinstellungenZuordnungProduktion.FieldName := 'ZuordnungProduktion';
    xdsPZEEinstellungenAuswahlNurKontaktnummer.SetParentComponent(xdsPZEEinstellungen);
    xdsPZEEinstellungenAuswahlNurKontaktnummer.Name := 'xdsPZEEinstellungenAuswahlNurKontaktnummer';
    xdsPZEEinstellungenAuswahlNurKontaktnummer.FieldName := 'AuswahlNurKontaktnummer';
    xdsPZEEinstellungenPauseVorgabe.SetParentComponent(xdsPZEEinstellungen);
    xdsPZEEinstellungenPauseVorgabe.Name := 'xdsPZEEinstellungenPauseVorgabe';
    xdsPZEEinstellungenPauseVorgabe.FieldName := 'PauseVorgabe';
    sourcePZEEinstellungen.SetParentComponent(Self);
    sourcePZEEinstellungen.Name := 'sourcePZEEinstellungen';
    sourcePZEEinstellungen.DataSet := xdsPZEEinstellungen;
    sourcePZEEinstellungen.Left := 104;
    sourcePZEEinstellungen.Top := 128;
    xdsStundenart.SetParentComponent(Self);
    xdsStundenart.Name := 'xdsStundenart';
    xdsStundenart.AfterOpen := xdsStundenartAfterOpen;
    xdsStundenart.EntitySetName := 'ObjekteStundenarten';
    xdsStundenart.Connection := DM2.XDataWebConnection1;
    xdsStundenart.Left := 152;
    xdsStundenart.Top := 440;
    xdsStundenartStundenArt.SetParentComponent(xdsStundenart);
    xdsStundenartStundenArt.Name := 'xdsStundenartStundenArt';
    xdsStundenartStundenArt.FieldName := 'StundenArt';
    xdsStundenartStundenArt.Required := True;
    xdsStundenartStundenArt.Size := 50;
    sourceStundenart.SetParentComponent(Self);
    sourceStundenart.Name := 'sourceStundenart';
    sourceStundenart.DataSet := xdsStundenart;
    sourceStundenart.Left := 72;
    sourceStundenart.Top := 440;
    xdsPauseFix.SetParentComponent(Self);
    xdsPauseFix.Name := 'xdsPauseFix';
    xdsPauseFix.AfterApplyUpdates := xdsPauseFixAfterApplyUpdates;
    xdsPauseFix.AfterOpen := xdsPauseFixAfterOpen;
    xdsPauseFix.AfterPost := xdsPauseFixAfterPost;
    xdsPauseFix.EntitySetName := 'PZE_ArbeitszeitenScan';
    xdsPauseFix.Connection := DM2.XDataWebConnection1;
    xdsPauseFix.Left := 296;
    xdsPauseFix.Top := 400;
    xdsPauseFixFAID.SetParentComponent(xdsPauseFix);
    xdsPauseFixFAID.Name := 'xdsPauseFixFAID';
    xdsPauseFixFAID.FieldName := 'FAID';
    xdsPauseFixFAID.Required := True;
    xdsPauseFixID.SetParentComponent(xdsPauseFix);
    xdsPauseFixID.Name := 'xdsPauseFixID';
    xdsPauseFixID.FieldName := 'ID';
    xdsPauseFixID.Required := True;
    xdsPauseFixID.Size := 38;
    xdsPauseFixPersonalnummer.SetParentComponent(xdsPauseFix);
    xdsPauseFixPersonalnummer.Name := 'xdsPauseFixPersonalnummer';
    xdsPauseFixPersonalnummer.FieldName := 'Personalnummer';
    xdsPauseFixPersonalnummer.Required := True;
    xdsPauseFixScanDatumZeit.SetParentComponent(xdsPauseFix);
    xdsPauseFixScanDatumZeit.Name := 'xdsPauseFixScanDatumZeit';
    xdsPauseFixScanDatumZeit.FieldName := 'ScanDatumZeit';
    xdsPauseFixDatum.SetParentComponent(xdsPauseFix);
    xdsPauseFixDatum.Name := 'xdsPauseFixDatum';
    xdsPauseFixDatum.FieldName := 'Datum';
    xdsPauseFixDatum.Required := True;
    xdsPauseFixScanArt.SetParentComponent(xdsPauseFix);
    xdsPauseFixScanArt.Name := 'xdsPauseFixScanArt';
    xdsPauseFixScanArt.FieldName := 'ScanArt';
    xdsPauseFixObjektreferenz.SetParentComponent(xdsPauseFix);
    xdsPauseFixObjektreferenz.Name := 'xdsPauseFixObjektreferenz';
    xdsPauseFixObjektreferenz.FieldName := 'Objektreferenz';
    xdsPauseFixObjektreferenz.Size := 13;
    xdsPauseFixScanBegin.SetParentComponent(xdsPauseFix);
    xdsPauseFixScanBegin.Name := 'xdsPauseFixScanBegin';
    xdsPauseFixScanBegin.FieldName := 'ScanBegin';
    xdsPauseFixScanEnde.SetParentComponent(xdsPauseFix);
    xdsPauseFixScanEnde.Name := 'xdsPauseFixScanEnde';
    xdsPauseFixScanEnde.FieldName := 'ScanEnde';
    xdsPauseFixausgewertet.SetParentComponent(xdsPauseFix);
    xdsPauseFixausgewertet.Name := 'xdsPauseFixausgewertet';
    xdsPauseFixausgewertet.FieldName := 'ausgewertet';
    xdsPauseFixAMS.SetParentComponent(xdsPauseFix);
    xdsPauseFixAMS.Name := 'xdsPauseFixAMS';
    xdsPauseFixAMS.FieldName := 'AMS';
    xdsPauseFixStundenArt.SetParentComponent(xdsPauseFix);
    xdsPauseFixStundenArt.Name := 'xdsPauseFixStundenArt';
    xdsPauseFixStundenArt.FieldName := 'StundenArt';
    xdsPauseFixStundenArt.Size := 50;
    xdsPauseFixKundennummer.SetParentComponent(xdsPauseFix);
    xdsPauseFixKundennummer.Name := 'xdsPauseFixKundennummer';
    xdsPauseFixKundennummer.FieldName := 'Kundennummer';
    xdsPauseFixKundennummer.Size := 13;
    xdsPauseFixAuftrag.SetParentComponent(xdsPauseFix);
    xdsPauseFixAuftrag.Name := 'xdsPauseFixAuftrag';
    xdsPauseFixAuftrag.FieldName := 'Auftrag';
    xdsPauseFixAuftrag.Size := 10;
    xdsPauseFixPAuftrag.SetParentComponent(xdsPauseFix);
    xdsPauseFixPAuftrag.Name := 'xdsPauseFixPAuftrag';
    xdsPauseFixPAuftrag.FieldName := 'PAuftrag';
    xdsPauseFixPAuftrag.Size := 10;
    xdsPauseFixArbeitArt.SetParentComponent(xdsPauseFix);
    xdsPauseFixArbeitArt.Name := 'xdsPauseFixArbeitArt';
    xdsPauseFixArbeitArt.FieldName := 'ArbeitArt';
    xdsPauseFixInfos.SetParentComponent(xdsPauseFix);
    xdsPauseFixInfos.Name := 'xdsPauseFixInfos';
    xdsPauseFixInfos.FieldName := 'Infos';
    xdsPauseFixInfos.Size := 255;
    xdsPauseFixDauerMinuten.SetParentComponent(xdsPauseFix);
    xdsPauseFixDauerMinuten.Name := 'xdsPauseFixDauerMinuten';
    xdsPauseFixDauerMinuten.FieldName := 'DauerMinuten';
    xdsPauseFixKalkStundensatz.SetParentComponent(xdsPauseFix);
    xdsPauseFixKalkStundensatz.Name := 'xdsPauseFixKalkStundensatz';
    xdsPauseFixKalkStundensatz.FieldName := 'KalkStundensatz';
    xdsPauseFixKalkKosten.SetParentComponent(xdsPauseFix);
    xdsPauseFixKalkKosten.Name := 'xdsPauseFixKalkKosten';
    xdsPauseFixKalkKosten.FieldName := 'KalkKosten';
  finally
    lblstatus.AfterLoadDFMValues;
    lblPInfo.AfterLoadDFMValues;
    WebDBLabel2.AfterLoadDFMValues;
    lblAutoObjekt.AfterLoadDFMValues;
    lblAutoAuftrag.AfterLoadDFMValues;
    panelfunktionen.AfterLoadDFMValues;
    btnAnmelden.AfterLoadDFMValues;
    btnPauseBeginn.AfterLoadDFMValues;
    btnPauseEnde.AfterLoadDFMValues;
    btnAbmelden.AfterLoadDFMValues;
    btnObjektBeginn.AfterLoadDFMValues;
    btnObjektEnde.AfterLoadDFMValues;
    btnErneutAnmelden.AfterLoadDFMValues;
    btnKontaktBeginn.AfterLoadDFMValues;
    btnKontaktEnde.AfterLoadDFMValues;
    btnAuftragBeginn.AfterLoadDFMValues;
    btnAuftragEnde.AfterLoadDFMValues;
    btnProduktionBeginn.AfterLoadDFMValues;
    btnProduktionEnde.AfterLoadDFMValues;
    btnPauseVorgabe.AfterLoadDFMValues;
    Container1.AfterLoadDFMValues;
    Container2.AfterLoadDFMValues;
    btnzurueck.AfterLoadDFMValues;
    TC.AfterLoadDFMValues;
    panelArbeitsart.AfterLoadDFMValues;
    lblauswahlinfo.AfterLoadDFMValues;
    radioarbeitsart.AfterLoadDFMValues;
    btnOK.AfterLoadDFMValues;
    btnAbbrechen.AfterLoadDFMValues;
    panelstundenart.AfterLoadDFMValues;
    lblauswahlobjekt.AfterLoadDFMValues;
    btnObjektOK.AfterLoadDFMValues;
    btnObjektAbbrechen.AfterLoadDFMValues;
    lookupstundenart.AfterLoadDFMValues;
    xdsSingleArbeitszeit.AfterLoadDFMValues;
    xdsSingleArbeitszeitID.AfterLoadDFMValues;
    xdsSingleArbeitszeitPersonalnummer.AfterLoadDFMValues;
    xdsSingleArbeitszeitDatum.AfterLoadDFMValues;
    xdsSingleArbeitszeitEintragsArt.AfterLoadDFMValues;
    xdsSingleArbeitszeitSollPause.AfterLoadDFMValues;
    sourceSingleArbeitszeit.AfterLoadDFMValues;
    xdsScan.AfterLoadDFMValues;
    xdsScanPersonalnummer.AfterLoadDFMValues;
    xdsScanScanDatumZeit.AfterLoadDFMValues;
    xdsScanDatum.AfterLoadDFMValues;
    xdsScanScanArt.AfterLoadDFMValues;
    xdsScanObjektreferenz.AfterLoadDFMValues;
    xdsScanScanBegin.AfterLoadDFMValues;
    xdsScanScanEnde.AfterLoadDFMValues;
    xdsScanausgewertet.AfterLoadDFMValues;
    xdsScanAMS.AfterLoadDFMValues;
    xdsScanStundenArt.AfterLoadDFMValues;
    xdsScanFAID.AfterLoadDFMValues;
    xdsScanID.AfterLoadDFMValues;
    xdsScanKundennummer.AfterLoadDFMValues;
    xdsScanAuftrag.AfterLoadDFMValues;
    xdsScanPAuftrag.AfterLoadDFMValues;
    xdsScanArbeitArt.AfterLoadDFMValues;
    xdsScanInfos.AfterLoadDFMValues;
    xdsScanDauerMinuten.AfterLoadDFMValues;
    xdsScanKalkStundensatz.AfterLoadDFMValues;
    xdsScanKalkKosten.AfterLoadDFMValues;
    sourceScan.AfterLoadDFMValues;
    xdsPZEEinstellungen.AfterLoadDFMValues;
    xdsPZEEinstellungenZuordnungObjekt.AfterLoadDFMValues;
    xdsPZEEinstellungenZuordnungKontakt.AfterLoadDFMValues;
    xdsPZEEinstellungenZuordnungAuftrag.AfterLoadDFMValues;
    xdsPZEEinstellungenZuordnungProduktion.AfterLoadDFMValues;
    xdsPZEEinstellungenAuswahlNurKontaktnummer.AfterLoadDFMValues;
    xdsPZEEinstellungenPauseVorgabe.AfterLoadDFMValues;
    sourcePZEEinstellungen.AfterLoadDFMValues;
    xdsStundenart.AfterLoadDFMValues;
    xdsStundenartStundenArt.AfterLoadDFMValues;
    sourceStundenart.AfterLoadDFMValues;
    xdsPauseFix.AfterLoadDFMValues;
    xdsPauseFixFAID.AfterLoadDFMValues;
    xdsPauseFixID.AfterLoadDFMValues;
    xdsPauseFixPersonalnummer.AfterLoadDFMValues;
    xdsPauseFixScanDatumZeit.AfterLoadDFMValues;
    xdsPauseFixDatum.AfterLoadDFMValues;
    xdsPauseFixScanArt.AfterLoadDFMValues;
    xdsPauseFixObjektreferenz.AfterLoadDFMValues;
    xdsPauseFixScanBegin.AfterLoadDFMValues;
    xdsPauseFixScanEnde.AfterLoadDFMValues;
    xdsPauseFixausgewertet.AfterLoadDFMValues;
    xdsPauseFixAMS.AfterLoadDFMValues;
    xdsPauseFixStundenArt.AfterLoadDFMValues;
    xdsPauseFixKundennummer.AfterLoadDFMValues;
    xdsPauseFixAuftrag.AfterLoadDFMValues;
    xdsPauseFixPAuftrag.AfterLoadDFMValues;
    xdsPauseFixArbeitArt.AfterLoadDFMValues;
    xdsPauseFixInfos.AfterLoadDFMValues;
    xdsPauseFixDauerMinuten.AfterLoadDFMValues;
    xdsPauseFixKalkStundensatz.AfterLoadDFMValues;
    xdsPauseFixKalkKosten.AfterLoadDFMValues;
  end;
end;

end.
